// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%2364748b%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  --bg: #f8fafc;
  --surface: #ffffff;
  --text: #1e293b;
  --text-muted: #64748b;
  --border: #e2e8f0;
  --primary: #4f46e5;
  --primary-hover: #4338ca;
  --primary-soft: #eef2ff;
  --success: #10b981;
  --success-soft: #ecfdf5;
  --warning: #f59e0b;
  --warning-soft: #fffbeb;
  --danger: #ef4444;
  --danger-soft: #fef2f2;
  --info: #3b82f6;
  --info-soft: #eff6ff;
  --radius: 12px;
  --radius-sm: 8px;
  --shadow: 0 1px 3px rgb(15 23 42 / 6%), 0 1px 2px rgb(15 23 42 / 4%);
  --shadow-md: 0 8px 24px rgb(15 23 42 / 8%);
  font-family: var(--font);
  line-height: 1.5;
  color: var(--text);
  background: var(--bg);
}

body {
  margin: 0;
  min-height: 100vh;
}

a {
  color: #1d4ed8;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.muted {
  color: #64748b;
  font-size: 0.9rem;
}

.muted.small {
  font-size: 0.8rem;
}

.err {
  color: #b91c1c;
  margin: 0;
  font-size: 0.9rem;
}

.error-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  cursor: help;
  color: #b91c1c;
  outline: none;
}

.error-tooltip__icon {
  width: 1.15rem;
  height: 1.15rem;
  display: block;
}

.error-tooltip__popup {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  z-index: 1050;
  bottom: calc(100% + 0.4rem);
  right: 0;
  width: max-content;
  max-width: min(22rem, 70vw);
  padding: 0.5rem 0.65rem;
  background: #1e293b;
  color: #f8fafc;
  font-size: 0.8rem;
  line-height: 1.45;
  font-weight: 400;
  border-radius: 0.4rem;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.2);
  pointer-events: none;
  transition: opacity 0.12s ease;
  white-space: normal;
  text-align: left;
}

.error-tooltip:hover .error-tooltip__popup,
.error-tooltip:focus-visible .error-tooltip__popup {
  visibility: visible;
  opacity: 1;
}

.success {
  color: #166534;
  margin: 0;
  font-size: 0.95rem;
}

.auth-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.auth-card {
  width: 100%;
  max-width: 22rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 1.75rem 1.5rem;
  box-shadow: 0 4px 24px rgb(15 23 42 / 8%);
}

.auth-card.flat {
  max-width: 40rem;
  box-shadow: 0 1px 2px rgb(15 23 42 / 6%);
}

.stat-card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.stat-card-link:hover {
  border-color: #0d6efd;
  box-shadow: 0 2px 8px rgb(13 110 253 / 12%);
}

.stat-card-link:focus-visible {
  outline: 2px solid #0d6efd;
  outline-offset: 2px;
}

.auth-card h1 {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  margin-top: 1.25rem;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.9rem;
}

.field span {
  font-weight: 600;
  color: #334155;
}

/* Portal form controls: .field children, layout helpers, and explicit classes */
:is(
  .field > input:not([type='checkbox']):not([type='radio']),
  .field > textarea,
  .field > select,
  .stack > input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),
  .stack > textarea,
  .stack > select,
  .inline-two input:not([type='checkbox']):not([type='radio']),
  .inline-two select,
  .row-actions > select,
  .form-control,
  .form-select
) {
  display: block;
  width: 100%;
}

:is(
  .field > input:not([type='checkbox']):not([type='radio']),
  .field > textarea,
  .field > select,
  .stack > input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),
  .stack > textarea,
  .stack > select,
  .inline-two input:not([type='checkbox']):not([type='radio']),
  .inline-two select,
  .row-actions > select,
  .form-control,
  .form-select
) {
  padding: 0.55rem 0.85rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #0f172a;
  background-color: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  box-shadow: 0 1px 2px rgb(15 23 42 / 4%);
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background-color 0.15s ease;
}

:is(
  .field > input:not([type='checkbox']):not([type='radio'])::placeholder,
  .field > textarea::placeholder,
  .stack > input:not([type='checkbox']):not([type='radio'])::placeholder,
  .stack > textarea::placeholder,
  .inline-two input:not([type='checkbox']):not([type='radio'])::placeholder,
  .form-control::placeholder
) {
  color: #94a3b8;
}

:is(
  .field > input:not([type='checkbox']):not([type='radio']):hover:not(:disabled):not(:focus),
  .field > textarea:hover:not(:disabled):not(:focus),
  .field > select:hover:not(:disabled):not(:focus),
  .stack > input:not([type='checkbox']):not([type='radio']):hover:not(:disabled):not(:focus),
  .stack > textarea:hover:not(:disabled):not(:focus),
  .stack > select:hover:not(:disabled):not(:focus),
  .inline-two input:not([type='checkbox']):not([type='radio']):hover:not(:disabled):not(:focus),
  .inline-two select:hover:not(:disabled):not(:focus),
  .row-actions > select:hover:not(:disabled):not(:focus),
  .form-control:hover:not(:disabled):not(:focus),
  .form-select:hover:not(:disabled):not(:focus)
) {
  border-color: #94a3b8;
}

:is(
  .field > input:not([type='checkbox']):not([type='radio']):focus,
  .field > textarea:focus,
  .field > select:focus,
  .stack > input:not([type='checkbox']):not([type='radio']):focus,
  .stack > textarea:focus,
  .stack > select:focus,
  .inline-two input:not([type='checkbox']):not([type='radio']):focus,
  .inline-two select:focus,
  .row-actions > select:focus,
  .form-control:focus,
  .form-select:focus
) {
  border-color: #0d6efd;
  outline: 0;
  box-shadow: 0 0 0 3px rgb(13 110 253 / 15%);
}

:is(
  .field > input:not([type='checkbox']):not([type='radio']):disabled,
  .field > textarea:disabled,
  .field > select:disabled,
  .stack > input:not([type='checkbox']):not([type='radio']):disabled,
  .stack > textarea:disabled,
  .stack > select:disabled,
  .inline-two input:not([type='checkbox']):not([type='radio']):disabled,
  .inline-two select:disabled,
  .row-actions > select:disabled,
  .form-control:disabled,
  .form-select:disabled
) {
  background-color: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
}

.field > input[type='file'] {
  padding: 0.45rem 0.65rem;
  font-size: 0.9rem;
}

:is(.field > select, .stack > select, .inline-two select, .row-actions > select, .form-select) {
  padding-right: 2.25rem;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 14px 10px;
}

.row-actions > select {
  width: auto;
  min-width: 14rem;
}

.field .form-control,
.field .form-select {
  width: 100%;
}

.search-form {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-bottom: 1rem;
  max-width: 100%;
}

.search-form .form-control {
  flex: 1;
  min-width: 12rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  box-shadow: none;
}

.search-form .btn-secondary,
.search-form .btn-primary {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-left: 1.1rem;
  padding-right: 1.1rem;
  white-space: nowrap;
}

.search-form:focus-within .form-control {
  border-right: 1px solid #0d6efd;
  margin-right: -1px;
  position: relative;
  z-index: 1;
}

.search-form:focus-within .btn-secondary,
.search-form:focus-within .btn-primary {
  border-color: #0d6efd;
  position: relative;
  z-index: 1;
}

.btn-primary,
.btn-secondary {
  margin: 0;
  padding: 0.55rem 1rem;
  border-radius: 0.45rem;
  font-size: 1rem;
  cursor: pointer;
  border: 1px solid transparent;
}

.btn-primary {
  background: #0f172a;
  color: #fff;
}

.btn-primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-secondary {
  background: #fff;
  color: #0f172a;
  border-color: #cbd5e1;
}

.btn-secondary:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #94a3b8;
}

.btn-danger {
  background: #b91c1c;
  color: #fff;
  border-color: #b91c1c;
}

.btn-danger:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgb(15 23 42 / 45%);
}

.modal-panel {
  width: 100%;
  max-width: 26rem;
  max-height: calc(100vh - 2.5rem);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 16px 48px rgb(15 23 42 / 20%);
  overflow: hidden;
}

.modal-panel--lg {
  max-width: 42rem;
}

.modal-panel--xl {
  max-width: 56rem;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.25rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.modal-title {
  margin: 0;
  font-size: 1.15rem;
}

.modal-description {
  margin: 0.35rem 0 0;
}

.modal-close {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 0.35rem;
  background: #f1f5f9;
  color: #334155;
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
}

.modal-close:hover {
  background: #e2e8f0;
}

.modal-body {
  padding: 1rem 1.25rem;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem 1.25rem;
  border-top: 1px solid #e2e8f0;
}

.faq-form-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr auto auto;
  gap: 0.5rem;
  align-items: end;
  margin-bottom: 0.5rem;
}

@media (max-width: 640px) {
  .faq-form-field-row {
    grid-template-columns: 1fr;
  }
}

.auth-links {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.field-errors {
  margin: 0;
  padding-left: 1.1rem;
  color: #b91c1c;
  font-size: 0.85rem;
}

.dashboard {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.header-nav-link {
  padding: 0.45rem 0.65rem;
  border-radius: 0.45rem;
  border: 1px solid transparent;
  background: transparent;
  color: #0f172a;
  font-size: 0.9rem;
  text-decoration: none;
  white-space: nowrap;
}

.header-nav-link:hover {
  text-decoration: none;
  background: #f8fafc;
  border-color: #e2e8f0;
}

.header-nav-link.is-active {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
  font-weight: 600;
}

.nav-dropdown {
  position: relative;
}

.nav-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.45rem 0.65rem;
  border-radius: 0.45rem;
  border: 1px solid transparent;
  background: transparent;
  color: #0f172a;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;
}

.nav-dropdown-trigger:hover,
.nav-dropdown.is-open .nav-dropdown-trigger {
  background: #f8fafc;
  border-color: #e2e8f0;
}

.nav-dropdown.is-active .nav-dropdown-trigger {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
  font-weight: 600;
}

.nav-dropdown-chevron {
  font-size: 0.7rem;
  opacity: 0.7;
  line-height: 1;
}

.nav-dropdown-panel {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 12rem;
  padding: 0.35rem;
  padding-top: 0.4rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);
  z-index: 200;
}

/* Invisible bridge so the pointer can move from trigger to panel without closing */
.nav-dropdown-panel::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -0.5rem;
  height: 0.5rem;
}

.nav-dropdown.is-open .nav-dropdown-panel {
  display: block;
}

.nav-dropdown-item {
  display: block;
  padding: 0.5rem 0.65rem;
  border-radius: 0.35rem;
  color: #0f172a;
  font-size: 0.9rem;
  text-decoration: none;
}

.nav-dropdown-item:hover {
  text-decoration: none;
  background: #f8fafc;
}

.nav-dropdown-item.is-active {
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}

.header-nav-utilities {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 0.25rem;
  padding-left: 0.75rem;
  border-left: 1px solid #e2e8f0;
}

@media (max-width: 900px) {
  .header-nav-utilities {
    border-left: none;
    padding-left: 0;
    margin-left: 0;
    width: 100%;
    justify-content: flex-end;
  }

  .nav-dropdown-panel {
    right: 0;
    left: auto;
  }
}

.dashboard-header h1 {
  margin: 0;
  font-size: 1.2rem;
}

.dashboard-main {
  flex: 1;
  padding: 1.5rem;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.mailbox-email-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  min-width: 0;
}

.mailbox-email-copy {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
  overflow: hidden;
}

.mailbox-email-open {
  flex: 0 0 auto;
}

.task-details {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  margin: 0.35rem 0 0;
}

.btn-link {
  padding: 0.45rem 0.65rem;
  border-radius: 0.45rem;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #0f172a;
  font-size: 0.95rem;
  text-decoration: none;
}

.btn-link:hover {
  text-decoration: none;
  background: #f8fafc;
}

.table-wrap {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.data-table th,
.data-table td {
  text-align: left;
  padding: 0.65rem 0.85rem;
  border-bottom: 1px solid #e2e8f0;
}

.data-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #334155;
}

.table-wrap .form-select {
  min-width: 10rem;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-list li {
  padding: 0.45rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.timeline {
  list-style: none;
  padding: 0;
  margin: 0;
}

.timeline li {
  padding: 0.65rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.sync-pre {
  background: #0f172a;
  color: #e2e8f0;
  padding: 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  overflow-x: auto;
}

.inline-two {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 0.5rem;
  margin-top: 0.5rem;
}


.card-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  padding: 1rem 1.1rem;
}

.template-choice-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  gap: 0.75rem;
}

.template-choice {
  text-align: left;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 0.9rem 1rem;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.template-choice:hover,
.template-choice.is-selected {
  border-color: var(--primary);
  background: var(--primary-soft);
}

.template-choice strong {
  display: block;
}

.template-choice--static {
  cursor: default;
}

.template-choice--static:hover {
  border-color: var(--border);
  background: #fff;
}

.template-catalog {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  gap: 0.9rem;
  margin-top: 1rem;
}

.template-card {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-width: 0;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 1rem 1.05rem 0.9rem;
  box-shadow: var(--shadow);
}

.template-card:hover {
  border-color: #c7d2fe;
  box-shadow: var(--shadow-md);
}

.template-card-link {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
  color: inherit;
  text-decoration: none;
}

.template-card-link:hover {
  color: inherit;
  text-decoration: none;
}

.template-card-link strong {
  font-size: 1.05rem;
  letter-spacing: -0.02em;
}

.template-card-kicker {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.template-card-flow {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin: 0.2rem 0 0;
}

.template-chip {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.72rem;
  font-weight: 600;
  color: #4338ca;
  background: var(--primary-soft);
  border-radius: 999px;
  padding: 0.12rem 0.5rem;
}

.tpl-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.tpl-head {
  position: sticky;
  top: 4rem;
  z-index: 15;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin: -1.5rem -1.5rem 0;
  padding: 0.75rem 1.5rem;
  background: color-mix(in srgb, var(--portal-content-bg, var(--bg)) 94%, white);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border);
}

.tpl-head-copy {
  min-width: 0;
}

.tpl-head .page-welcome-title {
  font-size: 1.35rem;
}

.tpl-head-status {
  flex: 1 0 100%;
}

.tpl-head-status .field-errors,
.tpl-head-status .err,
.tpl-head-status .success {
  margin: 0;
}

.tpl-lead {
  margin: 0.15rem 0 0;
  color: var(--text-muted);
}

.tpl-back {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0.35rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-decoration: none;
}

.tpl-back::before {
  content: '←';
}

.tpl-back:hover {
  text-decoration: none;
}

.tpl-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 18.5rem;
  gap: 1rem;
  align-items: start;
}

.tpl-panel {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: var(--shadow);
  padding: 1.1rem 1.15rem 1.2rem;
}

.tpl-section {
  margin-top: 1rem;
}

.tpl-section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
}

.tpl-section-head h3 {
  margin: 0;
  font-size: 1.05rem;
}

.tpl-section-head p {
  margin: 0.25rem 0 0;
  max-width: 40rem;
}

.tpl-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}

.tpl-form-grid .stack,
.tpl-pair .stack {
  margin-top: 0;
}

.tpl-pair {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 0.8fr);
  gap: 0.85rem;
  align-items: start;
}

.tpl-span-2 {
  grid-column: 1 / -1;
}

.tpl-summary {
  position: sticky;
  top: 8rem;
}

.tpl-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem 0.5rem;
  margin: 0.75rem 0 0;
}

.tpl-stats div {
  min-width: 0;
}

.tpl-stats dt {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.tpl-stats dd {
  margin: 0.1rem 0 0;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.tpl-outline {
  list-style: none;
  margin: 1rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.tpl-outline li {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.6rem;
  padding-top: 0.45rem;
  border-top: 1px solid var(--border);
  font-size: 0.88rem;
}

.tpl-outline li span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tpl-outline-swatch {
  display: inline-block;
  width: 0.55rem;
  height: 0.55rem;
  margin-right: 0.4rem;
  border-radius: 999px;
  vertical-align: 0.05em;
}

.tpl-pipeline {
  display: flex;
  gap: 0.75rem;
  overflow-x: auto;
  padding-bottom: 0.35rem;
  scroll-snap-type: x proximity;
}

.tpl-stage {
  flex: 0 0 17.5rem;
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.8rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #f8fafc;
}

.tpl-stage.is-done {
  border-color: #a7f3d0;
  background: #f0fdf4;
}

.tpl-stage.is-muted {
  background: #fff;
}

.tpl-stage.is-drop,
.tpl-task.is-drop {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgb(79 70 229 / 15%);
}

.tpl-stage-top,
.tpl-task-top {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.tpl-stage-num {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.tpl-stage-count {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.tpl-stage-moves {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: auto;
}

.tpl-drag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 6px;
  color: #94a3b8;
  cursor: grab;
}

.tpl-drag:active {
  cursor: grabbing;
}

.tpl-icon-btn {
  width: 1.85rem;
  height: 1.85rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  cursor: pointer;
}

.tpl-icon-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.tpl-stage-bar {
  height: 0.35rem;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.tpl-stage-bar span {
  display: block;
  height: 100%;
  background: var(--primary);
}

.tpl-stage.is-done .tpl-stage-bar span {
  background: var(--success);
}

.tpl-toggles {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.tpl-toggle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
}

.tpl-remove {
  align-self: flex-start;
  padding: 0.35rem 0.7rem;
}

.tpl-tasks {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.tpl-task {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.85rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #f8fafc;
}

.tpl-task-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(9rem, 0.8fr) minmax(9rem, 0.8fr);
  gap: 0.65rem;
}

.tpl-weight {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}

.tpl-weight > span {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-muted);
}

.tpl-weight-input {
  width: 4.5rem;
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  padding: 0.35rem 0.5rem;
}

.tpl-checklist {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
}

.tpl-checklist > span {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-muted);
}

.tpl-checklist ul {
  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.tpl-checklist li {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.tpl-checklist input {
  flex: 1;
  min-width: 0;
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  padding: 0.4rem 0.55rem;
  background: #fff;
}

@media (max-width: 960px) {
  .tpl-head {
    align-items: flex-start;
  }

  .tpl-head .row-actions {
    width: 100%;
  }

  .tpl-layout,
  .tpl-form-grid,
  .tpl-pair,
  .tpl-task-grid {
    grid-template-columns: 1fr;
  }

  .tpl-summary {
    position: static;
  }
}

.plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  gap: 1rem;
}

.plan-grid-wide {
  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
}

.plan-card h3 {
  margin: 0 0 0.35rem;
}

.plan-card-current {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}

.plan-card-price {
  margin: 0.5rem 0 0.75rem;
}

.plan-badge {
  display: inline-block;
  margin: 0 0 0.35rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.billing-page {
  max-width: 56rem;
}

.current-plan-panel {
  border-color: #2563eb;
}

.current-plan-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
}

.current-plan-price {
  text-align: right;
}

.plan-features {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.plan-feature-group-title {
  margin: 0 0 0.25rem;
  font-weight: 600;
}

.plan-feature-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.plan-feature-list li {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.plan-feature-label {
  font-size: 0.9rem;
}

.plan-features-compact .plan-feature-list {
  gap: 0.2rem;
}

.plan-features-compact .plan-feature-label {
  font-size: 0.85rem;
}

.plan-feature-desc {
  display: block;
  line-height: 1.35;
}

.plan-card .plan-features {
  flex: 1;
  margin-bottom: 1rem;
}

.plan-card {
  display: flex;
  flex-direction: column;
}

.list-plain {
  list-style: none;
  padding: 0;
  margin: 0;
}

.impersonation-banner {
  position: sticky;
  top: 0;
  z-index: 1050;
  background: linear-gradient(90deg, #b45309, #d97706);
  color: #fffbeb;
  border-bottom: 2px solid #92400e;
  box-shadow: 0 2px 8px rgb(146 64 14 / 25%);
}

.impersonation-banner-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.55rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.95rem;
}

.impersonation-banner strong {
  color: #fff;
}

.btn-sm {
  padding: 0.25rem 0.6rem;
  font-size: 0.85rem;
}

.faq-viewer .faq-category {
  margin-bottom: 2rem;
}

.faq-category-title {
  font-size: 1.15rem;
  margin: 0 0 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.faq-item-toggle {
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.faq-item-body {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border);
}

.faq-credentials {
  margin: 0.75rem 0;
}

.faq-credential-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  margin: 0.5rem 0;
}

.faq-credential-label {
  min-width: 5rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.faq-credential-value {
  flex: 1;
  min-width: 8rem;
  padding: 0.35rem 0.5rem;
  background: var(--surface-2, #f4f4f5);
  border-radius: 4px;
  font-size: 0.9rem;
}

.faq-image img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

.faq-media-caption {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  margin-top: 0.35rem;
  font-size: 0.85rem;
}

.faq-media-thumb {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
}

.faq-media-thumb img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.faq-media-thumb--file .faq-file-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border-radius: 4px;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.faq-media-name {
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 14rem;
}

.faq-file-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  margin: 0.5rem 0;
}

.faq-file-card-thumb {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.faq-file-icon--large {
  font-size: 2rem;
  line-height: 1;
}

.faq-file-card-meta {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.faq-file-card-name {
  word-break: break-word;
}

.faq-block-list {
  margin: 0.5rem 0 0;
}

.faq-block-list-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.faq-block-list-main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  flex: 1;
}

.faq-block-type-badge {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #64748b;
  background: #f1f5f9;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
}

.faq-form {
  max-width: 32rem;
  margin: 1rem 0;
}

.faq-admin-category h3 {
  font-size: 1.05rem;
}

.chat-widget-fab {
  position: fixed;
  right: 1.25rem;
  bottom: 1.25rem;
  z-index: 1000;
  width: 3.25rem;
  height: 3.25rem;
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 1.35rem;
  cursor: pointer;
  box-shadow: 0 4px 20px rgb(15 23 42 / 25%);
}

.chat-widget-fab:disabled {
  opacity: 0.7;
  cursor: wait;
}

.chat-widget-panel {
  position: fixed;
  right: 1.25rem;
  bottom: 5rem;
  z-index: 1000;
  width: min(22rem, calc(100vw - 2rem));
  max-height: min(32rem, calc(100vh - 6rem));
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  box-shadow: 0 8px 32px rgb(15 23 42 / 18%);
}

.chat-widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.chat-widget-panel .auth-card {
  box-shadow: none;
  border: none;
  padding: 0;
  min-height: auto;
}

.notif-prefs-table {
  display: grid;
  gap: 0.75rem;
}

.notif-prefs-head,
.notif-prefs-row {
  display: grid;
  grid-template-columns: 1fr 4rem 4rem;
  gap: 0.75rem;
  align-items: start;
}

.notif-prefs-head {
  font-size: 0.85rem;
  color: var(--muted, #64748b);
  border-bottom: 1px solid rgb(15 23 42 / 10%);
  padding-bottom: 0.35rem;
}

.notif-prefs-check {
  display: flex;
  justify-content: center;
  margin: 0;
}

.notif-bell-item + .notif-bell-item {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgb(15 23 42 / 8%);
}

.workspace-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.75rem;
}

.workspace-tab {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.85rem;
  cursor: pointer;
}

.workspace-tab.active {
  background: #1d4ed8;
  border-color: #1d4ed8;
  color: #fff;
}

.badge {
  display: inline-block;
  font-size: 0.75rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  white-space: nowrap;
}

.badge-ok {
  background: #dcfce7;
  color: #166534;
}

.badge-warn {
  background: #fef3c7;
  color: #92400e;
}

.integration-requirements {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border, #e5e7eb);
}

.integration-requirements-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}

.integration-requirements-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.5rem;
}

.integration-requirements-item {
  display: flex;
  gap: 0.65rem;
  align-items: flex-start;
  padding: 0.55rem 0.65rem;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 0.5rem;
  background: #fafafa;
}

.integration-requirements-body {
  flex: 1;
  min-width: 0;
}

.integration-requirements-title {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  font-size: 0.92rem;
}

.integration-requirements-meta {
  color: #6b7280;
  font-size: 0.75rem;
}

.integration-requirements-status {
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 0.15rem;
}

.integration-requirements-optional-label {
  margin: 0.85rem 0 0.45rem;
}

.integration-req-dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 999px;
  margin-top: 0.35rem;
  flex-shrink: 0;
}

.integration-req-ok,
.integration-req-dot.integration-req-ok {
  color: #166534;
}

.integration-req-dot.integration-req-ok {
  background: #22c55e;
}

.integration-req-missing,
.integration-req-dot.integration-req-missing {
  color: #6b7280;
}

.integration-req-dot.integration-req-missing {
  background: #9ca3af;
}

.integration-req-denied,
.integration-req-dot.integration-req-denied {
  color: #b91c1c;
}

.integration-req-dot.integration-req-denied {
  background: #ef4444;
}

.integration-req-skipped,
.integration-req-dot.integration-req-skipped {
  color: #92400e;
}

.integration-req-dot.integration-req-skipped {
  background: #f59e0b;
}

.integration-req-error,
.integration-req-dot.integration-req-error {
  color: #b91c1c;
}

.integration-req-dot.integration-req-error {
  background: #ef4444;
}

.integration-features-summary {
  display: grid;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.integration-features-group {
  padding: 0.65rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border, #e5e7eb);
}

.integration-features-available {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.integration-features-unavailable {
  background: #fef2f2;
  border-color: #fecaca;
}

.integration-features-title {
  margin: 0 0 0.35rem;
  font-size: 0.82rem;
  font-weight: 700;
}

.integration-features-available .integration-features-title {
  color: #166534;
}

.integration-features-unavailable .integration-features-title {
  color: #991b1b;
}

.integration-features-list {
  margin: 0;
  padding-left: 1.1rem;
  display: grid;
  gap: 0.35rem;
  font-size: 0.88rem;
}

.integration-features-list li {
  display: grid;
  gap: 0.1rem;
}

.integration-features-blockers {
  display: block;
}

.integration-req-impact {
  margin-top: 0.35rem;
  font-size: 0.82rem;
  line-height: 1.35;
}

.integration-req-impact-enabled {
  color: #166534;
}

.integration-req-impact-blocked {
  color: #991b1b;
}

.dashboard-integrations-card {
  margin-top: 0;
}

.dashboard-integrations-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.85rem;
}

.dashboard-integrations-summary {
  font-size: 0.8rem;
  color: #6b7280;
  background: #f3f4f6;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
}

.dashboard-integrations-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.45rem;
}

.dashboard-integrations-item {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.5rem 0.65rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.55rem;
  background: #fafafa;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.dashboard-integrations-item--full {
  background: #f7fdf9;
  border-color: #bbf7d0;
}

.dashboard-integrations-item--partial {
  background: #fffbeb;
  border-color: #fde68a;
}

.dashboard-integrations-item--none .dashboard-integrations-label {
  color: #6b7280;
}

.dashboard-integrations-copy {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.integration-status-icon {
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.05rem;
}

.integration-status-icon--ok {
  background: linear-gradient(145deg, #22c55e, #16a34a);
  color: #fff;
  box-shadow: 0 1px 4px rgb(22 163 74 / 28%);
}

.integration-status-icon--partial {
  background: linear-gradient(145deg, #f59e0b, #d97706);
  color: #fff;
  box-shadow: 0 1px 4px rgb(217 119 6 / 28%);
}

.integration-status-icon--missing {
  background: #f3f4f6;
  color: #9ca3af;
  border: 1px solid #e5e7eb;
}

.dashboard-integrations-label {
  font-size: 0.9rem;
  color: #1f2937;
  line-height: 1.25;
}

.dashboard-integrations-item--partial .dashboard-integrations-label {
  color: #92400e;
}

.dashboard-integrations-hint {
  font-size: 0.72rem;
  line-height: 1.25;
  color: #b45309;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard-integrations-link {
  display: inline-block;
  margin-top: 0.85rem;
}

/* Activity / audit log */
.audit-page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.audit-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0.65rem 1rem;
  background: linear-gradient(145deg, #f8fafc 0%, #eef2ff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  min-width: 5.5rem;
}

.audit-stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.1;
  color: #0f172a;
}

.audit-stat-label {
  font-size: 0.75rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.audit-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 1.25rem;
  padding: 0.85rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  max-width: none;
}

.audit-filters.search-form .form-control,
.audit-filters.search-form .form-select {
  flex: 0 1 auto;
  min-width: 9rem;
  max-width: 16rem;
  border-radius: 0.375rem;
  border-right: 1px solid #ced4da;
  margin-right: 0;
}

.audit-filters.search-form .form-control[type='date'] {
  min-width: 9.5rem;
}

.audit-filters.search-form .btn-secondary,
.audit-filters.search-form .btn-primary {
  border-radius: 0.375rem;
}

.audit-filters.search-form:focus-within .form-control {
  border-right: 1px solid #ced4da;
  margin-right: 0;
  z-index: auto;
}

.audit-empty {
  text-align: center;
  padding: 2.5rem 1.5rem;
  background: #fff;
  border: 1px dashed #cbd5e1;
  border-radius: 0.75rem;
}

.audit-empty-title {
  margin: 0 0 0.35rem;
  font-weight: 600;
  color: #0f172a;
}

.audit-feed {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.audit-item {
  display: flex;
  gap: 0.85rem;
  padding: 1rem 1.1rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.audit-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.audit-avatar {
  flex: 0 0 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: #1e3a5f;
  background: #e2e8f0;
}

.audit-item-body {
  flex: 1;
  min-width: 0;
}

.audit-item-top {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: baseline;
  flex-wrap: wrap;
  margin-bottom: 0.35rem;
}

.audit-when {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.1rem;
  white-space: nowrap;
}

.audit-when-rel {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}

.audit-what {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}

.audit-action {
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.audit-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.audit-summary {
  margin: 0.15rem 0 0.35rem;
  font-size: 0.9rem;
}

.audit-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.audit-details-toggle {
  padding: 0.1rem 0.35rem;
  font-size: 0.8rem;
}

.audit-details {
  margin: 0.65rem 0 0;
  padding: 0.65rem 0.75rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
}

.audit-detail-row {
  display: grid;
  grid-template-columns: minmax(6rem, 9rem) 1fr;
  gap: 0.5rem;
  padding: 0.25rem 0;
  font-size: 0.85rem;
}

.audit-detail-row dt {
  margin: 0;
  color: #64748b;
  text-transform: capitalize;
}

.audit-detail-row dd {
  margin: 0;
  color: #0f172a;
  word-break: break-word;
}

.audit-cat-clients {
  background: #dbeafe;
  color: #1e40af;
}
.audit-cat-projects {
  background: #dcfce7;
  color: #166534;
}
.audit-cat-tasks {
  background: #ffedd5;
  color: #9a3412;
}
.audit-cat-team {
  background: #ede9fe;
  color: #5b21b6;
}
.audit-cat-integrations {
  background: #e0f2fe;
  color: #075985;
}
.audit-cat-org {
  background: #f1f5f9;
  color: #334155;
}
.audit-cat-billing {
  background: #fef3c7;
  color: #92400e;
}
.audit-cat-security {
  background: #fee2e2;
  color: #991b1b;
}
.audit-cat-docs,
.audit-cat-assets {
  background: #fce7f3;
  color: #9d174d;
}
.audit-cat-other {
  background: #e2e8f0;
  color: #475569;
}

.audit-avatar.audit-cat-clients,
.audit-avatar.audit-cat-projects,
.audit-avatar.audit-cat-tasks,
.audit-avatar.audit-cat-team,
.audit-avatar.audit-cat-integrations,
.audit-avatar.audit-cat-org,
.audit-avatar.audit-cat-billing,
.audit-avatar.audit-cat-security,
.audit-avatar.audit-cat-docs,
.audit-avatar.audit-cat-assets,
.audit-avatar.audit-cat-other {
  border: none;
}

@media (max-width: 720px) {
  .audit-filters .form-control,
  .audit-filters .form-select {
    max-width: none;
    width: 100%;
    min-width: 0;
  }

  .audit-detail-row {
    grid-template-columns: 1fr;
    gap: 0.1rem;
  }

  .audit-when {
    align-items: flex-start;
  }
}

/* PDF editor */
.page-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

/* Full-viewport editor workspace (fixed to the screen — not % of a relative parent). */
.pdf-editor-layout {
  position: fixed !important;
  top: var(--pdf-editor-inset-top, 0px) !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 40;
  box-sizing: border-box;
  width: auto !important;
  max-width: none !important;
  height: auto !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0.65rem 1.25rem 0.75rem;
  display: flex !important;
  flex-direction: column !important;
  gap: 0;
  overflow: hidden !important;
  background: #eef2f7;
}

html.pdf-editor-page-active,
html.pdf-editor-page-active body,
body.pdf-editor-page-active {
  height: 100%;
  overflow: hidden !important;
}

body.pdf-editor-page-active .dashboard {
  min-height: 0 !important;
  height: 100dvh !important;
  max-height: 100dvh !important;
  overflow: hidden !important;
}

body.pdf-editor-page-active .dashboard-header {
  position: relative;
  z-index: 50;
  flex: 0 0 auto;
}

/* Outlet is taken out of flow by the fixed editor — keep main from creating a gray band. */
body.pdf-editor-page-active .dashboard-main {
  display: block !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: auto !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.pdf-editor-layout .page-header-row {
  flex: 0 0 auto;
  margin-bottom: 0.55rem;
  align-items: center;
  gap: 0.75rem;
}

.pdf-editor-layout .page-header-row h2 {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.25;
}

.pdf-editor-layout .page-header-row > div > .muted.small:last-child {
  display: none;
}

.pdf-editor-layout .page-header-row > div > .pdf-editor-size-line {
  display: block !important;
  margin: 0.15rem 0 0;
}

.pdf-editor-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.pdf-editor-size-box {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.55rem 0.65rem;
  border: 1px solid var(--border, #dbe1ea);
  border-radius: 8px;
  background: var(--surface-2, #f7f9fc);
}

.pdf-editor-size-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  font-size: 0.86rem;
}

.pdf-editor-size-row span {
  color: var(--muted, #64748b);
}

/* Editor left + settings column right */
.pdf-editor-grid {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: stretch !important;
  gap: 0.85rem;
  width: 100%;
  flex: 1 1 0 !important;
  min-height: 0 !important;
  height: auto !important;
  overflow: hidden;
}

.pdf-editor-main {
  flex: 1 1 0 !important;
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
  min-height: 0 !important;
  height: auto !important;
}

.pdf-editor-sidebar {
  flex: 0 0 300px !important;
  width: 300px !important;
  max-width: 300px !important;
  min-width: 300px !important;
  min-height: 0 !important;
  height: auto !important;
  align-self: stretch;
  overflow: auto;
  overscroll-behavior: contain;
  margin-top: 0 !important;
}

.pdf-editor-sidebar .field {
  margin-bottom: 0.65rem;
}

.pdf-margin-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.45rem;
  margin-top: 0.35rem;
}

.pdf-margin-field,
.pdf-margin-all {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.8rem;
  color: #475569;
}

.pdf-margin-field input,
.pdf-margin-all input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.35rem 0.45rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.4rem;
  font-size: 0.9rem;
}

.pdf-margin-all {
  margin-top: 0.45rem;
}

.pdf-editor-layout > .err,
.pdf-editor-layout > .ok {
  flex: 0 0 auto;
  margin: 0 0 0.5rem;
}

.pdf-editor-sidebar .auth-card.flat {
  max-width: none !important;
  width: 100% !important;
  box-sizing: border-box;
}

.pdf-editor-main.auth-card.flat {
  padding: 0 !important;
  overflow: hidden;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  max-width: none !important;
  width: auto !important;
  min-height: 0 !important;
  height: auto !important;
  flex: 1 1 0 !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Word-like document shell — flex-sized, not height:100% of a relative parent */
.pdf-word-shell {
  position: relative;
  background: #c5cad3;
  border: 1px solid #c5ccd6;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  flex: 1 1 0;
  min-height: 0;
  height: auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

.pdf-word-titlebar {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  flex-shrink: 0;
  padding: 0 14px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  border-bottom: 1px solid #cfd6e0;
}

.pdf-word-titlebar-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #c4c9d2;
}

.pdf-word-titlebar-dot:nth-child(1) { background: #ff5f57; }
.pdf-word-titlebar-dot:nth-child(2) { background: #febc2e; }
.pdf-word-titlebar-dot:nth-child(3) { background: #28c840; }

.pdf-word-titlebar-name {
  margin-left: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}

.pdf-word-zoom {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.pdf-word-zoom-btn {
  width: 26px;
  height: 26px;
  border: 1px solid #c5ccd6;
  border-radius: 6px;
  background: #fff;
  color: #334155;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.pdf-word-zoom-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.pdf-word-zoom-btn:not(:disabled):hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.pdf-word-zoom-select {
  height: 26px;
  border: 1px solid #c5ccd6;
  border-radius: 6px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  padding: 0 6px;
  cursor: pointer;
}

.pdf-word-textarea-seed {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  opacity: 0 !important;
  pointer-events: none !important;
  left: -9999px !important;
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

.pdf-word-editor-host {
  flex: 1 1 0;
  min-height: 0;
  height: auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

.pdf-word-shell .tox-tinymce {
  border: 0 !important;
  border-radius: 0 !important;
  width: 100% !important;
  height: 100% !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
}

/* TinyMCE fullscreen must own the real viewport — escape parent stacking contexts. */
.tox.tox-tinymce.tox-fullscreen,
.tox-tinymce.tox-fullscreen,
.tox-fullscreen .tox-tinymce {
  position: fixed !important;
  inset: 0 !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important;
  max-height: none !important;
  min-width: 100vw !important;
  min-height: 100vh !important;
  z-index: 2147483000 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #ffffff !important;
  display: flex !important;
  flex-direction: column !important;
  pointer-events: auto !important;
  visibility: visible !important;
  opacity: 1 !important;
}

body.tox-fullscreen,
html.tox-fullscreen {
  overflow: hidden !important;
}

/* Parent layout stacking context (z-index:40) trapped TinyMCE under the site header (50).
   Raise + expand the editor shell above chrome while FS is on — never reparent the iframe. */
body.tox-fullscreen .pdf-editor-layout {
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 2147482900 !important;
  padding: 0 !important;
  background: #c5cad3 !important;
}

body.tox-fullscreen .pdf-editor-layout .page-header-row,
body.tox-fullscreen .pdf-editor-layout .pdf-editor-sidebar,
body.tox-fullscreen .pdf-editor-layout > .err,
body.tox-fullscreen .pdf-editor-layout > .ok {
  display: none !important;
}

body.tox-fullscreen .pdf-editor-layout .pdf-editor-grid,
body.tox-fullscreen .pdf-editor-layout .pdf-editor-main,
body.tox-fullscreen .pdf-editor-layout .pdf-word-shell,
body.tox-fullscreen .pdf-editor-layout .pdf-word-editor-host {
  position: absolute !important;
  inset: 0 !important;
  width: auto !important;
  height: auto !important;
  max-width: none !important;
  min-width: 0 !important;
  min-height: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  overflow: hidden !important;
  pointer-events: auto !important;
  background: transparent !important;
}

body.tox-fullscreen .pdf-editor-layout .pdf-word-titlebar {
  display: none !important;
}

body.tox-fullscreen .pdf-editor-layout .tox-tinymce,
body.tox-fullscreen .pdf-editor-layout .tox-tinymce.tox-fullscreen {
  pointer-events: auto !important;
}

body.tox-fullscreen .dashboard-header,
body.tox-fullscreen .impersonation-banner,
body.tox-fullscreen .impersonation-banner-inner,
body.tox-fullscreen .portal-preview-banner {
  z-index: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

/* Keep document pages visible inside the FS iframe */
body.tox-fullscreen .tox-edit-area__iframe {
  background: #c5cad3 !important;
}

.tox-tinymce.tox-fullscreen .tox-editor-header {
  display: grid !important;
  grid-template-columns: 1fr min-content !important;
  flex: 0 0 auto !important;
  visibility: visible !important;
  opacity: 1 !important;
  background: #ffffff !important;
  box-shadow: 0 1px 0 #d5dbe5 !important;
  padding: 4px 0 !important;
  position: relative !important;
  z-index: 5 !important;
}

.tox-tinymce.tox-fullscreen .tox-menubar,
.tox-tinymce.tox-fullscreen .tox-toolbar-overlord,
.tox-tinymce.tox-fullscreen .tox-toolbar__primary,
.tox-tinymce.tox-fullscreen .tox-toolbar__overflow,
.tox-tinymce.tox-fullscreen .tox-toolbar {
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
  height: auto !important;
  max-height: none !important;
  pointer-events: auto !important;
}

.tox-tinymce.tox-fullscreen .tox-sidebar-wrap {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}

.tox-tinymce.tox-fullscreen .tox-edit-area {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: auto !important;
  display: flex !important;
}

.tox-tinymce.tox-fullscreen .tox-edit-area__iframe {
  flex: 1 1 auto !important;
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
}

.tox-tinymce.tox-fullscreen .tox-statusbar {
  display: flex !important;
  visibility: visible !important;
  flex: 0 0 auto !important;
}

.pdf-word-shell .tox-editor-header {
  background: #f3f5f8 !important;
  box-shadow: inset 0 -1px 0 #d5dbe5 !important;
  padding: 4px 6px 2px !important;
}

.pdf-word-shell .tox-menubar,
.pdf-word-shell .tox-toolbar-overlord,
.pdf-word-shell .tox-toolbar__primary {
  background: transparent !important;
}

.pdf-word-shell .tox-statusbar {
  background: #f8fafc !important;
  border-top: 1px solid #d5dbe5 !important;
}

.pdf-word-shell .tox-edit-area__iframe {
  background: #edf0f4 !important;
}

.pdf-word-shell:not(.is-ready) .tox-tinymce {
  opacity: 0;
}

.pdf-word-loading {
  position: absolute;
  inset: 38px 0 0;
  display: grid;
  place-items: center;
  background:
    radial-gradient(circle at top, rgba(255,255,255,.55), transparent 45%),
    #e5e9ef;
  z-index: 2;
}

.pdf-word-loading-card {
  width: min(420px, calc(100% - 48px));
  background: #fff;
  border: 1px solid #d7dde7;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.1);
  padding: 28px 24px;
  text-align: center;
}

.pdf-word-loading-card p {
  margin: 14px 0 0;
  color: #475569;
  font-size: 0.95rem;
}

.pdf-word-loading-spinner {
  width: 34px;
  height: 34px;
  margin: 0 auto;
  border-radius: 50%;
  border: 3px solid #dbe3ef;
  border-top-color: #2563eb;
  animation: pdf-word-spin 0.8s linear infinite;
}

@keyframes pdf-word-spin {
  to { transform: rotate(360deg); }
}

.pdf-word-error {
  margin: 48px auto;
  max-width: 480px;
  background: #fff;
  border: 1px solid #fecaca;
  color: #991b1b;
  border-radius: 10px;
  padding: 20px;
}

.pdf-preview-frame {
  width: 100%;
  flex: 1;
  min-height: 0;
  height: 100%;
  border: 1px solid #c5ccd6;
  border-radius: 10px;
  background: #edf0f4;
}

.pdf-html-preview {
  width: 100%;
  flex: 1;
  min-height: 0;
  height: 100%;
  border: 1px solid #c5ccd6;
  border-radius: 10px;
  background: #fff;
  overflow: auto;
}

.pdf-html-preview-doc {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  padding: 32px 40px 56px;
  font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
  font-size: 11pt;
  line-height: 1.5;
  color: #111827;
}

.pdf-html-preview-doc h1 { font-size: 24pt; line-height: 1.25; margin: 0 0 14pt; font-weight: 700; }
.pdf-html-preview-doc h2 { font-size: 16pt; line-height: 1.3; margin: 18pt 0 10pt; font-weight: 700; }
.pdf-html-preview-doc h3 { font-size: 13pt; line-height: 1.35; margin: 14pt 0 8pt; font-weight: 700; }
.pdf-html-preview-doc p { margin: 0 0 10pt; }
.pdf-html-preview-doc ul,
.pdf-html-preview-doc ol { margin: 0 0 10pt; padding-left: 24pt; }
.pdf-html-preview-doc li { margin: 0 0 4pt; }
.pdf-html-preview-doc img { max-width: 100%; height: auto; }
.pdf-html-preview-doc table { width: 100%; border-collapse: collapse; margin: 12pt 0; }
.pdf-html-preview-doc td,
.pdf-html-preview-doc th { border: 1px solid #9ca3af; padding: 6pt 8pt; vertical-align: top; }

.pdf-editor-pages {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.pdf-editor-page-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.pdf-editor-page-label {
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 600;
}

.pdf-editor-page {
  position: relative;
  margin: 0 auto;
  border: 1px solid #cbd5e1;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.pdf-editor-page canvas {
  display: block;
  width: 100%;
  height: 100%;
}

.pdf-editor-page.tool-text,
.pdf-editor-page.tool-image {
  cursor: crosshair;
}

.pdf-overlay {
  position: absolute;
  z-index: 2;
  background: rgba(255, 255, 255, 0.78);
  border: 1px dashed #94a3b8;
  border-radius: 4px;
  padding: 2px;
  box-sizing: border-box;
  cursor: move;
  touch-action: none;
}

.pdf-overlay.is-image {
  background: transparent;
  padding: 0;
  overflow: hidden;
}

.pdf-overlay.is-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
}

.pdf-overlay-image-empty {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  min-height: 48px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
}

.pdf-overlay.is-selected {
  border-color: #2563eb;
  background: rgba(219, 234, 254, 0.85);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.pdf-overlay.is-image.is-selected {
  background: transparent;
}

.pdf-overlay textarea {
  width: 100%;
  min-height: 48px;
  border: 0;
  background: transparent;
  resize: vertical;
  font: inherit;
  color: inherit;
  line-height: 1.25;
  padding: 0.15rem;
  cursor: text;
}

.pdf-overlay-remove {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 0;
  background: #dc2626;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  z-index: 3;
}

.pdf-overlay-resize {
  position: absolute;
  right: -6px;
  bottom: -6px;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  background: #2563eb;
  border: 2px solid #fff;
  cursor: nwse-resize;
  z-index: 3;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.25);
}

.ok {
  color: #047857;
  font-size: 0.92rem;
}

.pm2-logs-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
}

.pm2-logs-controls .field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.pm2-logs-type {
  min-width: 8rem;
  width: 8rem;
}

.pm2-logs-controls .pm2-logs-load {
  align-self: flex-end;
}

.pm2-system-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.75rem 1rem;
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 8px;
  background: var(--bs-tertiary-bg, #f8f9fa);
}

.pm2-system-metrics > div {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.pm2-system-metrics strong {
  font-size: 0.95rem;
}

.pm2-sort-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  color: inherit;
  cursor: pointer;
}

.pm2-sort-btn:hover {
  color: #0f172a;
}

.pm2-sort-indicator {
  font-size: 0.65rem;
  line-height: 1;
  opacity: 0.35;
}

.pm2-sort-btn.is-active .pm2-sort-indicator {
  opacity: 1;
}

.docker-projects {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.docker-project {
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 8px;
  background: var(--bs-body-bg, #fff);
  overflow: hidden;
}

.docker-project-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem 1rem;
  padding: 0.75rem 0.9rem;
  background: var(--bs-tertiary-bg, #f8f9fa);
}

.docker-project-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  flex: 1 1 220px;
  min-width: 0;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
  color: inherit;
}

.docker-project-chevron {
  width: 1rem;
  color: var(--bs-secondary-color, #6c757d);
}

.docker-project-name {
  font-weight: 600;
  font-size: 1rem;
}

.docker-project-meta {
  display: inline-flex;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.docker-project-actions {
  margin-left: auto;
}

.docker-project-containers {
  border-top: 1px solid var(--bs-border-color, #dee2e6);
  margin: 0;
}

.docker-project-containers .data-table {
  margin: 0;
}

.npm-script-list {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 0.75rem 0.9rem 0.9rem;
  border-top: 1px solid var(--bs-border-color, #dee2e6);
}

.npm-script-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.npm-script-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.npm-script-copy code {
  color: var(--bs-secondary-color, #6c757d);
  font-size: 0.78rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.npm-script-output {
  margin: 0.35rem 0 0;
  max-height: 320px;
  overflow: auto;
  background: var(--bs-tertiary-bg, #f8f9fa);
  padding: 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  white-space: pre-wrap;
}

.npm-kind {
  margin-left: 0.45rem;
  padding: 0.05rem 0.4rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #475569;
  background: #e2e8f0;
}

.npm-kind-engine {
  color: #5b21b6;
  background: #ede9fe;
}

.npm-kind-site {
  color: #1d4ed8;
  background: #dbeafe;
}

.npm-site-row {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
  max-width: 100%;
}

.npm-stage {
  padding: 0.05rem 0.45rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
}

.npm-stage-live {
  color: #166534;
  background: #dcfce7;
}

.npm-stage-staging {
  color: #854d0e;
  background: #fef9c3;
}

.npm-stage-down {
  color: #991b1b;
  background: #fee2e2;
}

.npm-site-link {
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8rem;
}

.npm-version-row {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-left: auto;
}

.npm-version-chip,
.npm-version-btn {
  border-radius: 999px;
  padding: 0.2rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 700;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  line-height: 1.3;
}

.npm-version-chip.is-latest {
  color: #1d4ed8;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}

.npm-version-chip.is-stuck {
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.npm-version-btn {
  cursor: pointer;
}

.npm-version-btn.is-behind {
  color: #fff;
  background: #dc2626;
  border: 1px solid #b91c1c;
}

.npm-version-btn:disabled {
  opacity: 0.7;
  cursor: progress;
}

.npm-script-block + .npm-script-block {
  padding-top: 0.65rem;
  border-top: 1px solid var(--bs-border-color, #e9ecef);
}

.npm-script-form {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem 0.75rem;
  align-items: end;
  margin-top: 0.55rem;
}

.npm-script-form .field {
  margin: 0;
  min-width: 11rem;
  flex: 1 1 11rem;
}

.npm-script-check {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 2.1rem;
  font-size: 0.85rem;
}

.npm-script-check code,
.npm-script-preview code {
  font-size: 0.75rem;
}

.npm-script-preview {
  margin: 0.35rem 0 0;
}

.integrations-table-row {
  cursor: pointer;
}

.integrations-table-row:hover > td {
  background: var(--bs-tertiary-bg, #f8f9fa);
}

.integrations-table-row:focus-visible {
  outline: 2px solid var(--bs-primary, #0d6efd);
  outline-offset: -2px;
}

.integrations-table-summary {
  max-width: 28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integration-editor .stack {
  gap: 0.85rem;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
}

@media (max-width: 720px) {
  .pdf-editor-layout {
    padding: 0.5rem 0.75rem 0.65rem;
  }

  .pdf-editor-grid {
    flex-direction: column !important;
    overflow: auto;
  }

  .pdf-editor-sidebar {
    flex: 0 0 auto !important;
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    height: auto !important;
    max-height: 38vh;
  }

  .pdf-word-shell,
  .pdf-editor-main.auth-card.flat {
    min-height: 52vh;
  }
}

.task-board {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  overflow-x: auto;
  padding: 0.25rem 0.15rem 1rem;
  margin-top: 0.75rem;
}

.task-column {
  flex: 0 0 18.5rem;
  width: 18.5rem;
  max-height: calc(100vh - 13rem);
  display: flex;
  flex-direction: column;
  background: var(--stage-wash, #f1f2f4);
  border-radius: 0.75rem;
}

.task-column.is-drop {
  background: var(--stage-wash-strong, #e4e6ea);
}

.task-column-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.7rem 0.75rem 0.35rem;
}

.task-column-title {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-width: 0;
}

.task-column-head .task-column-mark {
  flex: 0 0 1.35rem;
  width: 1.35rem;
  height: 1.35rem;
  color: var(--stage-color, #64748b);
}

.task-column-mark svg {
  display: block;
  width: 100%;
  height: 100%;
}

.task-column-head .task-column-count {
  min-width: 1.4rem;
  height: 1.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: rgb(255 255 255 / 72%);
  color: #44546f;
  font-size: 0.75rem;
  font-weight: 650;
}

.task-column-head h3 {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 650;
}

.task-column-progress {
  margin: 0.1rem 0 0;
  color: #626f86;
  font-size: 0.75rem;
}

.task-card-weight {
  display: inline-block;
  margin-top: 0.35rem;
  color: #626f86;
  font-size: 0.75rem;
}

.task-stage-toolbar,
.task-stage-editor {
  margin-top: 0.75rem;
}

.task-stage-toolbar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.task-stage-toolbar p {
  margin: 0;
}

.task-stage-editor {
  padding: 0.9rem 1rem 1rem;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 1px 2px rgb(15 23 42 / 8%);
}

.task-stage-editor-head,
.task-stage-editor-actions {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.task-stage-editor-head h3 {
  margin: 0 0 0.25rem;
  font-size: 1rem;
}

.task-stage-editor-head p {
  margin: 0;
  max-width: 42rem;
}

.task-stage-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin: 0.85rem 0;
}

.task-stage-row {
  display: grid;
  grid-template-columns: minmax(9rem, 1.4fr) auto 6rem auto auto auto auto;
  gap: 0.65rem;
  align-items: end;
  padding-bottom: 0.65rem;
  border-bottom: 1px solid #e6e8ec;
}

.task-stage-swatches {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 2.4rem;
}

.task-stage-swatches button {
  width: 1.35rem;
  height: 1.35rem;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 999px;
  box-shadow: 0 0 0 1px #d0d5dd;
  cursor: pointer;
}

.task-stage-swatches button.is-selected,
.task-stage-swatches button:focus-visible {
  box-shadow: 0 0 0 2px var(--primary, #4f46e5);
}

.task-stage-swatches input[type='color'] {
  width: 1.7rem;
  height: 1.7rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.task-stage-check {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.45rem;
  font-size: 0.85rem;
}

.task-stage-row-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.15rem;
}

.weight-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.4rem;
}

.weight-presets button {
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  padding: 0.15rem 0.55rem;
  background: #fff;
  font-size: 0.75rem;
}

.weight-presets button.is-selected {
  border-color: var(--primary, #3b5bdb);
  color: var(--primary, #3b5bdb);
}

@media (max-width: 900px) {
  .task-stage-row {
    grid-template-columns: 1fr 1fr;
  }
}

.task-column-head span {
  color: #626f86;
  font-size: 0.8rem;
}

.task-column-cards {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow-y: auto;
  min-height: 0.5rem;
  padding: 0.35rem 0.5rem 0.15rem;
}

.task-card {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.65rem 0.7rem;
  border: none;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0 1px 1px rgb(9 30 66 / 25%);
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.task-card:hover {
  background: #f7f8f9;
}

.task-card.is-dragging {
  opacity: 0.45;
}

.task-card-title {
  display: block;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.35;
}

.task-card-project,
.task-card-preview {
  display: -webkit-box;
  margin-top: 0.3rem;
  overflow: hidden;
  color: #626f86;
  font-size: 0.78rem;
  line-height: 1.35;
  white-space: pre-wrap;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.task-card-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.5rem;
}

.task-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.4rem;
  border-radius: 0.3rem;
  background: #f1f2f4;
  color: #44546f;
  font-size: 0.75rem;
}

.task-chip.is-overdue,
.task-chip.is-urgent {
  background: #ffebe6;
  color: #ae2e24;
}

.task-chip.is-high {
  background: #fff3eb;
  color: #c25100;
}

.task-chip.is-medium {
  background: #e9f2ff;
  color: #0c66e4;
}

.task-chip.is-waiting {
  background: #fff7d6;
  color: #7f5f01;
}

.task-chip.is-request {
  background: #e3fcef;
  color: #216e4e;
}

.task-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem 0.85rem;
  margin-top: 0.85rem;
}

.task-view-toggle,
.task-quick-filters,
.task-filter-selects {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.task-view-toggle button,
.task-quick-filters button {
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  padding: 0.2rem 0.7rem;
  background: #fff;
  color: #344054;
  font: inherit;
  font-size: 0.82rem;
  cursor: pointer;
}

.task-view-toggle button.is-selected,
.task-quick-filters button.is-selected {
  border-color: var(--primary, #3b5bdb);
  background: #eef2ff;
  color: var(--primary, #3b5bdb);
}

.task-filter-selects select {
  border: 1px solid #d0d5dd;
  border-radius: 0.45rem;
  padding: 0.28rem 0.45rem;
  background: #fff;
  font: inherit;
  font-size: 0.82rem;
}

.task-list {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  margin-top: 0.85rem;
}

.task-list h3 {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.45rem;
  font-size: 0.95rem;
}

.task-list h3 span,
.task-card-assignee {
  color: #626f86;
  font-size: 0.78rem;
  font-weight: 500;
}

.task-card-assignee.is-empty {
  font-style: italic;
}

.task-list-cards {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.task-checklist {
  list-style: none;
  margin: 0 0 0.5rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.task-checklist li {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.task-checklist input[type='text'],
.task-checklist li > input:not([type='checkbox']) {
  flex: 1;
  min-width: 0;
  border: 1px solid #d0d5dd;
  border-radius: 0.4rem;
  padding: 0.35rem 0.5rem;
  font: inherit;
}

.task-checklist .is-done {
  text-decoration: line-through;
  color: #626f86;
}

.task-more {
  position: relative;
}

.task-more-menu {
  position: absolute;
  z-index: 5;
  top: calc(100% + 0.25rem);
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.35rem;
  border-radius: 0.55rem;
  background: #fff;
  box-shadow: 0 8px 24px rgb(15 23 42 / 16%);
}

.task-more-menu > button {
  border: none;
  border-radius: 0.35rem;
  background: transparent;
  padding: 0.4rem 0.5rem;
  text-align: left;
  font: inherit;
  cursor: pointer;
}

.task-more-menu > button:hover {
  background: #f1f2f4;
}

.task-more-menu .is-danger {
  color: #ae2e24;
}

.task-waiting-dialog {
  width: min(26rem, 100%);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.task-waiting-dialog h3 {
  margin: 0;
}

.task-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 999px;
  background: #172b4d;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
}

.task-card-meta .task-avatar {
  margin-left: auto;
}

.task-add,
.task-composer-cancel {
  border: none;
  background: transparent;
  color: #44546f;
  cursor: pointer;
}

.task-add {
  margin: 0.15rem 0.5rem 0.5rem;
  padding: 0.45rem 0.55rem;
  border-radius: 0.5rem;
  text-align: left;
  font: inherit;
}

.task-add:hover,
.task-composer-cancel:hover {
  background: #dcdfe4;
}

.task-composer {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin: 0.15rem 0.5rem 0.5rem;
}

.task-composer textarea,
.task-composer select,
.task-dialog textarea,
.task-dialog-title {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  background: #fff;
  color: #0f172a;
  font: inherit;
}

.task-composer textarea,
.task-dialog textarea {
  padding: 0.55rem 0.65rem;
  resize: vertical;
}

.task-composer select {
  padding: 0.45rem 0.55rem;
}

.task-composer-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.task-composer-cancel {
  width: 2rem;
  height: 2rem;
  border-radius: 0.35rem;
  font-size: 1.25rem;
  line-height: 1;
}

.task-dialog {
  position: relative;
  width: min(52rem, 100%);
  max-height: calc(100vh - 2.5rem);
  overflow: auto;
  padding: 1.25rem 1.25rem 1.4rem;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 16px 48px rgb(15 23 42 / 20%);
}

.task-dialog-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
}

.task-dialog-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 16rem;
  gap: 1.25rem;
}

.task-dialog-title {
  margin: 0 2rem 0 0;
  padding: 0.35rem 0.5rem;
  font-size: 1.25rem;
  font-weight: 700;
}

h3.task-dialog-title {
  border: none;
  padding-left: 0;
}

.task-dialog-kicker {
  margin: 0.35rem 0 1rem;
}

.task-dialog-main h4 {
  margin: 0 0 0.4rem;
  font-size: 0.95rem;
}

.task-dialog-side {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.75rem;
  padding-top: 2.4rem;
}

.task-dialog-side .btn-primary,
.task-dialog-side .btn-link,
.task-dialog-side .btn-secondary,
.task-dialog-side .btn-danger {
  width: 100%;
  text-align: center;
}

.task-delete-confirm p {
  margin: 0;
  font-size: 0.85rem;
}

@media (max-width: 800px) {
  .task-dialog-layout {
    grid-template-columns: 1fr;
  }

  .task-dialog-side {
    padding-top: 0;
  }
}

.task-activity {
  margin-top: 1.25rem;
}

.task-activity h4,
.task-dialog-main h4 {
  margin: 0;
}

.task-activity-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.task-activity-head .btn-secondary {
  width: auto;
}

.task-dropzone {
  margin-bottom: 1.25rem;
  padding: 0.65rem;
  border: 1px dashed #cbd5e1;
  border-radius: 0.6rem;
  background: #f8fafc;
}

.task-dropzone.is-active {
  border-color: #4f46e5;
  background: #eef2ff;
}

.task-attachment-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.task-attachment {
  width: 8.5rem;
  margin: 0;
}

.task-attachment-preview,
.task-attachment-file {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 6.5rem;
  padding: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.45rem;
  background: #fff;
  cursor: pointer;
}

.task-attachment-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.task-attachment-file {
  padding: 0.5rem;
  color: #1e293b;
  font-size: 0.78rem;
  text-align: center;
}

.task-attachment figcaption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  margin-top: 0.25rem;
  color: #64748b;
  font-size: 0.72rem;
}

.task-attachment figcaption span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.task-attachment figcaption button,
.task-comment-meta button {
  border: none;
  background: none;
  color: #64748b;
  font: inherit;
  cursor: pointer;
}

.task-comments {
  list-style: none;
  margin: 0.65rem 0 0.85rem;
  padding: 0;
}

.task-comment {
  display: grid;
  grid-template-columns: 1.75rem minmax(0, 1fr);
  column-gap: 0.65rem;
  align-items: start;
  margin-bottom: 0.9rem;
}

.task-comment .task-avatar {
  width: 1.75rem;
  height: 1.75rem;
  margin-top: 0.1rem;
}

.task-comment-body {
  min-width: 0;
}

.task-comments p {
  margin: 0.15rem 0 0;
  color: #1e293b;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.task-comment-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.5rem;
}

.task-comment-meta strong {
  color: #172b4d;
}

.task-comment-meta .muted {
  margin-right: auto;
}

.task-comment-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
}

.task-comment-form textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 0.55rem 0.65rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  font: inherit;
  resize: vertical;
}

.mail-page-intro {
  overflow-wrap: anywhere;
}

.mail-client {
  display: grid;
  grid-template-columns: minmax(16rem, 22rem) minmax(0, 1fr);
  gap: 1rem;
  align-items: start;
}

.mail-list,
.mail-reader {
  min-width: 0;
}

.mail-toolbar {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-bottom: 0.65rem;
}

.mail-toolbar-actions,
.mail-folders {
  display: grid;
  gap: 0.4rem;
  min-width: 0;
}

.mail-toolbar-actions {
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
}

.mail-folders {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.mail-toolbar-actions button,
.mail-folders button {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding-left: 0.35rem;
  padding-right: 0.35rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mail-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
}

.mail-search {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin: 0 0 0.75rem;
  min-width: 0;
}

.mail-search .form-control {
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  box-shadow: none;
}

.mail-search .btn-secondary {
  flex: 0 0 auto;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  white-space: nowrap;
}

.mail-search:focus-within .form-control {
  border-right: 1px solid #0d6efd;
  margin-right: -1px;
  position: relative;
  z-index: 1;
}

.mail-search:focus-within .btn-secondary {
  border-color: #0d6efd;
  position: relative;
  z-index: 1;
}

.mail-compose input,
.mail-compose textarea {
  width: 100%;
  box-sizing: border-box;
}

.mail-list-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  width: 100%;
  margin-bottom: 0.45rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.55rem;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.mail-list-item.is-active {
  border-color: #7c3aed;
  background: #f5f3ff;
}

.mail-list-item .is-unread {
  font-weight: 700;
}

.mail-preview {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mail-subject {
  margin: 0 0 0.35rem;
}

.mail-body {
  margin: 0.75rem 0;
  padding: 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.55rem;
  background: #fff;
  overflow: auto;
  max-height: 32rem;
  line-height: 1.45;
}

.mail-body img {
  max-width: 100%;
  height: auto;
}

.mail-file-list {
  list-style: none;
  margin: 0.35rem 0 0;
  padding: 0;
}

.mail-file-list li,
.mail-attachments li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.mail-signature {
  margin: 0.5rem 0 0.75rem;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.55rem;
  background: #fff;
}

.mail-attachments {
  list-style: none;
  margin: 0 0 0.75rem;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.mail-back {
  display: none;
  margin-bottom: 0.5rem;
}

.mail-toolbar .is-active {
  border-color: #7c3aed;
  color: #5b21b6;
}

@media (max-width: 800px) {
  .mail-client {
    grid-template-columns: 1fr;
  }

  .mail-client.has-selection .mail-list {
    display: none;
  }

  .mail-client:not(.has-selection) .mail-reader {
    display: none;
  }

  .mail-back {
    display: inline-flex;
  }
}

.searchable-select {
  position: relative;
  display: block;
  width: 100%;
  min-width: 0;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  height: auto !important;
  min-height: 0 !important;
  appearance: none;
}

.searchable-select-trigger {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  cursor: pointer;
  font: inherit;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #0f172a;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 14px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  padding: 0.55rem 2.25rem 0.55rem 0.85rem;
  box-shadow: 0 1px 2px rgb(15 23 42 / 4%);
}

.searchable-select-value {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.searchable-select-trigger:hover:not(:disabled) {
  border-color: #94a3b8;
}

.searchable-select-trigger:focus,
.searchable-select.is-open .searchable-select-trigger {
  border-color: #0d6efd;
  outline: 0;
  box-shadow: 0 0 0 3px rgb(13 110 253 / 15%);
}

.searchable-select-trigger:disabled {
  background-color: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
}

.searchable-select-trigger.form-select-sm {
  padding: 0.25rem 1.8rem 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.375rem;
}

.searchable-select-native {
  position: absolute;
  inset: auto 0 0;
  width: 100%;
  height: 1px;
  margin: 0;
  padding: 0;
  border: 0;
  opacity: 0;
  pointer-events: none;
}

.searchable-select-menu {
  position: fixed;
  z-index: 1400;
  display: flex;
  flex-direction: column;
  max-height: min(20rem, calc(100vh - 16px));
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  box-shadow: 0 12px 32px rgb(15 23 42 / 16%);
  overflow: hidden;
}

.searchable-select-search {
  margin: 0.4rem;
  padding: 0.4rem 0.6rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.4rem;
  font: inherit;
  font-size: 0.9rem;
  color: #0f172a;
  background: #fff;
}

.searchable-select-search:focus {
  border-color: #0d6efd;
  outline: 0;
  box-shadow: 0 0 0 3px rgb(13 110 253 / 15%);
}

.searchable-select-list {
  overflow: auto;
  padding: 0.15rem 0.15rem 0.35rem;
}

.searchable-select-option {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 0.4rem 0.55rem;
  border-radius: 0.35rem;
  font: inherit;
  font-size: 0.9rem;
  color: #0f172a;
  cursor: pointer;
}

.searchable-select-option.is-active,
.searchable-select-option:hover:not(:disabled) {
  background: #eef2ff;
}

.searchable-select-option.is-selected {
  font-weight: 600;
}

.searchable-select-option:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.searchable-select-empty {
  margin: 0;
  padding: 0.35rem 0.7rem 0.65rem;
  color: #64748b;
  font-size: 0.85rem;
}

.task-filter-selects .searchable-select,
.row-actions > .searchable-select,
.audit-filters .searchable-select,
.pm2-logs-controls .searchable-select,
.pdf-word-zoom .searchable-select {
  width: auto;
}

.task-filter-selects .searchable-select-trigger {
  width: auto;
  min-width: 8.5rem;
  padding: 0.28rem 1.7rem 0.28rem 0.45rem;
  border-radius: 0.45rem;
  font-size: 0.82rem;
  box-shadow: none;
}

.row-actions > .searchable-select {
  min-width: 14rem;
}

.audit-filters .searchable-select {
  flex: 0 1 auto;
  min-width: 9rem;
  max-width: 16rem;
}

.pdf-word-zoom .searchable-select-trigger {
  width: auto;
  height: 26px;
  padding: 0 1.5rem 0 6px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  box-shadow: none;
}

`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,iEAAiE;EACjE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,oEAAoE;EACpE,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;EAC5C,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;;;;;;;;;;;;;EAaE,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;;;;;;;;EAaE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;EACxC;;;+BAG6B;AAC/B;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;EAaE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;EAaE,qBAAqB;EACrB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;;;EAaE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yDAAiP;EACjP,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,YAAY;AACd;;AAEA,mFAAmF;AACnF;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,8EAA8E;EAC9E,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+EAA+E;EAC/E,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,6DAA6D;EAC7D,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;;EAWE,YAAY;AACd;;AAEA;EACE;;IAEE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,uFAAuF;AACvF;EACE,0BAA0B;EAC1B,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,wBAAwB;EACxB,iCAAiC;EACjC,MAAM;EACN,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA,2FAA2F;AAC3F;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sCAAsC,mBAAmB,EAAE;AAC3D,sCAAsC,mBAAmB,EAAE;AAC3D,sCAAsC,mBAAmB,EAAE;;AAE3D;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;EAC/B,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,qFAAqF;AACrF;;;EAGE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;6FAC6F;AAC7F;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;EAIE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;EAIE,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,qDAAqD;AACrD;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;EACjD,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;;;;EAKE,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB;;WAES;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,2EAA2E;EAC3E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACnG,2BAA2B,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACrG,2BAA2B,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACrG,0BAA0B,gBAAgB,EAAE;AAC5C;2BAC2B,gBAAgB,EAAE,kBAAkB,EAAE;AACjE,2BAA2B,eAAe,EAAE;AAC5C,4BAA4B,eAAe,EAAE,YAAY,EAAE;AAC3D,8BAA8B,WAAW,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACtF;2BAC2B,yBAAyB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE7F;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qEAAqE;EACrE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wEAAwE;EACxE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;;;EAIE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yDAAiP;EACjP,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[":root {\n  --font: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;\n  --bg: #f8fafc;\n  --surface: #ffffff;\n  --text: #1e293b;\n  --text-muted: #64748b;\n  --border: #e2e8f0;\n  --primary: #4f46e5;\n  --primary-hover: #4338ca;\n  --primary-soft: #eef2ff;\n  --success: #10b981;\n  --success-soft: #ecfdf5;\n  --warning: #f59e0b;\n  --warning-soft: #fffbeb;\n  --danger: #ef4444;\n  --danger-soft: #fef2f2;\n  --info: #3b82f6;\n  --info-soft: #eff6ff;\n  --radius: 12px;\n  --radius-sm: 8px;\n  --shadow: 0 1px 3px rgb(15 23 42 / 6%), 0 1px 2px rgb(15 23 42 / 4%);\n  --shadow-md: 0 8px 24px rgb(15 23 42 / 8%);\n  font-family: var(--font);\n  line-height: 1.5;\n  color: var(--text);\n  background: var(--bg);\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n}\n\na {\n  color: #1d4ed8;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.muted {\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.muted.small {\n  font-size: 0.8rem;\n}\n\n.err {\n  color: #b91c1c;\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.error-tooltip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  cursor: help;\n  color: #b91c1c;\n  outline: none;\n}\n\n.error-tooltip__icon {\n  width: 1.15rem;\n  height: 1.15rem;\n  display: block;\n}\n\n.error-tooltip__popup {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  z-index: 1050;\n  bottom: calc(100% + 0.4rem);\n  right: 0;\n  width: max-content;\n  max-width: min(22rem, 70vw);\n  padding: 0.5rem 0.65rem;\n  background: #1e293b;\n  color: #f8fafc;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  font-weight: 400;\n  border-radius: 0.4rem;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.2);\n  pointer-events: none;\n  transition: opacity 0.12s ease;\n  white-space: normal;\n  text-align: left;\n}\n\n.error-tooltip:hover .error-tooltip__popup,\n.error-tooltip:focus-visible .error-tooltip__popup {\n  visibility: visible;\n  opacity: 1;\n}\n\n.success {\n  color: #166534;\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.auth-shell {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 22rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  padding: 1.75rem 1.5rem;\n  box-shadow: 0 4px 24px rgb(15 23 42 / 8%);\n}\n\n.auth-card.flat {\n  max-width: 40rem;\n  box-shadow: 0 1px 2px rgb(15 23 42 / 6%);\n}\n\n.stat-card-link {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.stat-card-link:hover {\n  border-color: #0d6efd;\n  box-shadow: 0 2px 8px rgb(13 110 253 / 12%);\n}\n\n.stat-card-link:focus-visible {\n  outline: 2px solid #0d6efd;\n  outline-offset: 2px;\n}\n\n.auth-card h1 {\n  margin: 0 0 0.35rem;\n  font-size: 1.35rem;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  margin-top: 1.25rem;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.9rem;\n}\n\n.field span {\n  font-weight: 600;\n  color: #334155;\n}\n\n/* Portal form controls: .field children, layout helpers, and explicit classes */\n:is(\n  .field > input:not([type='checkbox']):not([type='radio']),\n  .field > textarea,\n  .field > select,\n  .stack > input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),\n  .stack > textarea,\n  .stack > select,\n  .inline-two input:not([type='checkbox']):not([type='radio']),\n  .inline-two select,\n  .row-actions > select,\n  .form-control,\n  .form-select\n) {\n  display: block;\n  width: 100%;\n}\n\n:is(\n  .field > input:not([type='checkbox']):not([type='radio']),\n  .field > textarea,\n  .field > select,\n  .stack > input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),\n  .stack > textarea,\n  .stack > select,\n  .inline-two input:not([type='checkbox']):not([type='radio']),\n  .inline-two select,\n  .row-actions > select,\n  .form-control,\n  .form-select\n) {\n  padding: 0.55rem 0.85rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #0f172a;\n  background-color: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.45rem;\n  box-shadow: 0 1px 2px rgb(15 23 42 / 4%);\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    background-color 0.15s ease;\n}\n\n:is(\n  .field > input:not([type='checkbox']):not([type='radio'])::placeholder,\n  .field > textarea::placeholder,\n  .stack > input:not([type='checkbox']):not([type='radio'])::placeholder,\n  .stack > textarea::placeholder,\n  .inline-two input:not([type='checkbox']):not([type='radio'])::placeholder,\n  .form-control::placeholder\n) {\n  color: #94a3b8;\n}\n\n:is(\n  .field > input:not([type='checkbox']):not([type='radio']):hover:not(:disabled):not(:focus),\n  .field > textarea:hover:not(:disabled):not(:focus),\n  .field > select:hover:not(:disabled):not(:focus),\n  .stack > input:not([type='checkbox']):not([type='radio']):hover:not(:disabled):not(:focus),\n  .stack > textarea:hover:not(:disabled):not(:focus),\n  .stack > select:hover:not(:disabled):not(:focus),\n  .inline-two input:not([type='checkbox']):not([type='radio']):hover:not(:disabled):not(:focus),\n  .inline-two select:hover:not(:disabled):not(:focus),\n  .row-actions > select:hover:not(:disabled):not(:focus),\n  .form-control:hover:not(:disabled):not(:focus),\n  .form-select:hover:not(:disabled):not(:focus)\n) {\n  border-color: #94a3b8;\n}\n\n:is(\n  .field > input:not([type='checkbox']):not([type='radio']):focus,\n  .field > textarea:focus,\n  .field > select:focus,\n  .stack > input:not([type='checkbox']):not([type='radio']):focus,\n  .stack > textarea:focus,\n  .stack > select:focus,\n  .inline-two input:not([type='checkbox']):not([type='radio']):focus,\n  .inline-two select:focus,\n  .row-actions > select:focus,\n  .form-control:focus,\n  .form-select:focus\n) {\n  border-color: #0d6efd;\n  outline: 0;\n  box-shadow: 0 0 0 3px rgb(13 110 253 / 15%);\n}\n\n:is(\n  .field > input:not([type='checkbox']):not([type='radio']):disabled,\n  .field > textarea:disabled,\n  .field > select:disabled,\n  .stack > input:not([type='checkbox']):not([type='radio']):disabled,\n  .stack > textarea:disabled,\n  .stack > select:disabled,\n  .inline-two input:not([type='checkbox']):not([type='radio']):disabled,\n  .inline-two select:disabled,\n  .row-actions > select:disabled,\n  .form-control:disabled,\n  .form-select:disabled\n) {\n  background-color: #f8fafc;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.field > input[type='file'] {\n  padding: 0.45rem 0.65rem;\n  font-size: 0.9rem;\n}\n\n:is(.field > select, .stack > select, .inline-two select, .row-actions > select, .form-select) {\n  padding-right: 2.25rem;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 14px 10px;\n}\n\n.row-actions > select {\n  width: auto;\n  min-width: 14rem;\n}\n\n.field .form-control,\n.field .form-select {\n  width: 100%;\n}\n\n.search-form {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  margin-bottom: 1rem;\n  max-width: 100%;\n}\n\n.search-form .form-control {\n  flex: 1;\n  min-width: 12rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n  box-shadow: none;\n}\n\n.search-form .btn-secondary,\n.search-form .btn-primary {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding-left: 1.1rem;\n  padding-right: 1.1rem;\n  white-space: nowrap;\n}\n\n.search-form:focus-within .form-control {\n  border-right: 1px solid #0d6efd;\n  margin-right: -1px;\n  position: relative;\n  z-index: 1;\n}\n\n.search-form:focus-within .btn-secondary,\n.search-form:focus-within .btn-primary {\n  border-color: #0d6efd;\n  position: relative;\n  z-index: 1;\n}\n\n.btn-primary,\n.btn-secondary {\n  margin: 0;\n  padding: 0.55rem 1rem;\n  border-radius: 0.45rem;\n  font-size: 1rem;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.btn-primary {\n  background: #0f172a;\n  color: #fff;\n}\n\n.btn-primary:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #fff;\n  color: #0f172a;\n  border-color: #cbd5e1;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #94a3b8;\n}\n\n.btn-danger {\n  background: #b91c1c;\n  color: #fff;\n  border-color: #b91c1c;\n}\n\n.btn-danger:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgb(15 23 42 / 45%);\n}\n\n.modal-panel {\n  width: 100%;\n  max-width: 26rem;\n  max-height: calc(100vh - 2.5rem);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 0.75rem;\n  box-shadow: 0 16px 48px rgb(15 23 42 / 20%);\n  overflow: hidden;\n}\n\n.modal-panel--lg {\n  max-width: 42rem;\n}\n\n.modal-panel--xl {\n  max-width: 56rem;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.25rem 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 1.15rem;\n}\n\n.modal-description {\n  margin: 0.35rem 0 0;\n}\n\n.modal-close {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  border-radius: 0.35rem;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.modal-close:hover {\n  background: #e2e8f0;\n}\n\n.modal-body {\n  padding: 1rem 1.25rem;\n  overflow-y: auto;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0.75rem 1.25rem 1.25rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.faq-form-field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto auto;\n  gap: 0.5rem;\n  align-items: end;\n  margin-bottom: 0.5rem;\n}\n\n@media (max-width: 640px) {\n  .faq-form-field-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.auth-links {\n  margin-top: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.field-errors {\n  margin: 0;\n  padding-left: 1.1rem;\n  color: #b91c1c;\n  font-size: 0.85rem;\n}\n\n.dashboard {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.header-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-wrap: wrap;\n}\n\n.header-nav-link {\n  padding: 0.45rem 0.65rem;\n  border-radius: 0.45rem;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #0f172a;\n  font-size: 0.9rem;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.header-nav-link:hover {\n  text-decoration: none;\n  background: #f8fafc;\n  border-color: #e2e8f0;\n}\n\n.header-nav-link.is-active {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n  font-weight: 600;\n}\n\n.nav-dropdown {\n  position: relative;\n}\n\n.nav-dropdown-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.45rem 0.65rem;\n  border-radius: 0.45rem;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #0f172a;\n  font-size: 0.9rem;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.nav-dropdown-trigger:hover,\n.nav-dropdown.is-open .nav-dropdown-trigger {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n}\n\n.nav-dropdown.is-active .nav-dropdown-trigger {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n  font-weight: 600;\n}\n\n.nav-dropdown-chevron {\n  font-size: 0.7rem;\n  opacity: 0.7;\n  line-height: 1;\n}\n\n.nav-dropdown-panel {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 12rem;\n  padding: 0.35rem;\n  padding-top: 0.4rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);\n  z-index: 200;\n}\n\n/* Invisible bridge so the pointer can move from trigger to panel without closing */\n.nav-dropdown-panel::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: -0.5rem;\n  height: 0.5rem;\n}\n\n.nav-dropdown.is-open .nav-dropdown-panel {\n  display: block;\n}\n\n.nav-dropdown-item {\n  display: block;\n  padding: 0.5rem 0.65rem;\n  border-radius: 0.35rem;\n  color: #0f172a;\n  font-size: 0.9rem;\n  text-decoration: none;\n}\n\n.nav-dropdown-item:hover {\n  text-decoration: none;\n  background: #f8fafc;\n}\n\n.nav-dropdown-item.is-active {\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-weight: 600;\n}\n\n.header-nav-utilities {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-left: 0.25rem;\n  padding-left: 0.75rem;\n  border-left: 1px solid #e2e8f0;\n}\n\n@media (max-width: 900px) {\n  .header-nav-utilities {\n    border-left: none;\n    padding-left: 0;\n    margin-left: 0;\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .nav-dropdown-panel {\n    right: 0;\n    left: auto;\n  }\n}\n\n.dashboard-header h1 {\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n.dashboard-main {\n  flex: 1;\n  padding: 1.5rem;\n}\n\n.row-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.mailbox-email-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.mailbox-email-copy {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow-wrap: anywhere;\n  overflow: hidden;\n}\n\n.mailbox-email-open {\n  flex: 0 0 auto;\n}\n\n.task-details {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  margin: 0.35rem 0 0;\n}\n\n.btn-link {\n  padding: 0.45rem 0.65rem;\n  border-radius: 0.45rem;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #0f172a;\n  font-size: 0.95rem;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  text-decoration: none;\n  background: #f8fafc;\n}\n\n.table-wrap {\n  overflow-x: auto;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\n.data-table th,\n.data-table td {\n  text-align: left;\n  padding: 0.65rem 0.85rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.data-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #334155;\n}\n\n.table-wrap .form-select {\n  min-width: 10rem;\n}\n\n.link-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.link-list li {\n  padding: 0.45rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.timeline {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.timeline li {\n  padding: 0.65rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.sync-pre {\n  background: #0f172a;\n  color: #e2e8f0;\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  font-size: 0.8rem;\n  overflow-x: auto;\n}\n\n.inline-two {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n\n.card-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.65rem;\n  padding: 1rem 1.1rem;\n}\n\n.template-choice-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));\n  gap: 0.75rem;\n}\n\n.template-choice {\n  text-align: left;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 0.9rem 1rem;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n}\n\n.template-choice:hover,\n.template-choice.is-selected {\n  border-color: var(--primary);\n  background: var(--primary-soft);\n}\n\n.template-choice strong {\n  display: block;\n}\n\n.template-choice--static {\n  cursor: default;\n}\n\n.template-choice--static:hover {\n  border-color: var(--border);\n  background: #fff;\n}\n\n.template-catalog {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));\n  gap: 0.9rem;\n  margin-top: 1rem;\n}\n\n.template-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  min-width: 0;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 1rem 1.05rem 0.9rem;\n  box-shadow: var(--shadow);\n}\n\n.template-card:hover {\n  border-color: #c7d2fe;\n  box-shadow: var(--shadow-md);\n}\n\n.template-card-link {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n  color: inherit;\n  text-decoration: none;\n}\n\n.template-card-link:hover {\n  color: inherit;\n  text-decoration: none;\n}\n\n.template-card-link strong {\n  font-size: 1.05rem;\n  letter-spacing: -0.02em;\n}\n\n.template-card-kicker {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.template-card-flow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin: 0.2rem 0 0;\n}\n\n.template-chip {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #4338ca;\n  background: var(--primary-soft);\n  border-radius: 999px;\n  padding: 0.12rem 0.5rem;\n}\n\n.tpl-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.tpl-head {\n  position: sticky;\n  top: 4rem;\n  z-index: 15;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  margin: -1.5rem -1.5rem 0;\n  padding: 0.75rem 1.5rem;\n  background: color-mix(in srgb, var(--portal-content-bg, var(--bg)) 94%, white);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border);\n}\n\n.tpl-head-copy {\n  min-width: 0;\n}\n\n.tpl-head .page-welcome-title {\n  font-size: 1.35rem;\n}\n\n.tpl-head-status {\n  flex: 1 0 100%;\n}\n\n.tpl-head-status .field-errors,\n.tpl-head-status .err,\n.tpl-head-status .success {\n  margin: 0;\n}\n\n.tpl-lead {\n  margin: 0.15rem 0 0;\n  color: var(--text-muted);\n}\n\n.tpl-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-bottom: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.tpl-back::before {\n  content: '←';\n}\n\n.tpl-back:hover {\n  text-decoration: none;\n}\n\n.tpl-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 18.5rem;\n  gap: 1rem;\n  align-items: start;\n}\n\n.tpl-panel {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  box-shadow: var(--shadow);\n  padding: 1.1rem 1.15rem 1.2rem;\n}\n\n.tpl-section {\n  margin-top: 1rem;\n}\n\n.tpl-section-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.9rem;\n}\n\n.tpl-section-head h3 {\n  margin: 0;\n  font-size: 1.05rem;\n}\n\n.tpl-section-head p {\n  margin: 0.25rem 0 0;\n  max-width: 40rem;\n}\n\n.tpl-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.85rem;\n}\n\n.tpl-form-grid .stack,\n.tpl-pair .stack {\n  margin-top: 0;\n}\n\n.tpl-pair {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(0, 0.8fr);\n  gap: 0.85rem;\n  align-items: start;\n}\n\n.tpl-span-2 {\n  grid-column: 1 / -1;\n}\n\n.tpl-summary {\n  position: sticky;\n  top: 8rem;\n}\n\n.tpl-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem 0.5rem;\n  margin: 0.75rem 0 0;\n}\n\n.tpl-stats div {\n  min-width: 0;\n}\n\n.tpl-stats dt {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.tpl-stats dd {\n  margin: 0.1rem 0 0;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.tpl-outline {\n  list-style: none;\n  margin: 1rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.tpl-outline li {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.6rem;\n  padding-top: 0.45rem;\n  border-top: 1px solid var(--border);\n  font-size: 0.88rem;\n}\n\n.tpl-outline li span:first-child {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tpl-outline-swatch {\n  display: inline-block;\n  width: 0.55rem;\n  height: 0.55rem;\n  margin-right: 0.4rem;\n  border-radius: 999px;\n  vertical-align: 0.05em;\n}\n\n.tpl-pipeline {\n  display: flex;\n  gap: 0.75rem;\n  overflow-x: auto;\n  padding-bottom: 0.35rem;\n  scroll-snap-type: x proximity;\n}\n\n.tpl-stage {\n  flex: 0 0 17.5rem;\n  scroll-snap-align: start;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding: 0.8rem;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.tpl-stage.is-done {\n  border-color: #a7f3d0;\n  background: #f0fdf4;\n}\n\n.tpl-stage.is-muted {\n  background: #fff;\n}\n\n.tpl-stage.is-drop,\n.tpl-task.is-drop {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgb(79 70 229 / 15%);\n}\n\n.tpl-stage-top,\n.tpl-task-top {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.tpl-stage-num {\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.tpl-stage-count {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.tpl-stage-moves {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-left: auto;\n}\n\n.tpl-drag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 6px;\n  color: #94a3b8;\n  cursor: grab;\n}\n\n.tpl-drag:active {\n  cursor: grabbing;\n}\n\n.tpl-icon-btn {\n  width: 1.85rem;\n  height: 1.85rem;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n}\n\n.tpl-icon-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.tpl-stage-bar {\n  height: 0.35rem;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.tpl-stage-bar span {\n  display: block;\n  height: 100%;\n  background: var(--primary);\n}\n\n.tpl-stage.is-done .tpl-stage-bar span {\n  background: var(--success);\n}\n\n.tpl-toggles {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.tpl-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.tpl-remove {\n  align-self: flex-start;\n  padding: 0.35rem 0.7rem;\n}\n\n.tpl-tasks {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.tpl-task {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding: 0.85rem;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.tpl-task-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.5fr) minmax(9rem, 0.8fr) minmax(9rem, 0.8fr);\n  gap: 0.65rem;\n}\n\n.tpl-weight {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.tpl-weight > span {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--text-muted);\n}\n\n.tpl-weight-input {\n  width: 4.5rem;\n  border: 1px solid #dbe3ee;\n  border-radius: 10px;\n  padding: 0.35rem 0.5rem;\n}\n\n.tpl-checklist {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.4rem;\n}\n\n.tpl-checklist > span {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--text-muted);\n}\n\n.tpl-checklist ul {\n  list-style: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.tpl-checklist li {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.tpl-checklist input {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #dbe3ee;\n  border-radius: 10px;\n  padding: 0.4rem 0.55rem;\n  background: #fff;\n}\n\n@media (max-width: 960px) {\n  .tpl-head {\n    align-items: flex-start;\n  }\n\n  .tpl-head .row-actions {\n    width: 100%;\n  }\n\n  .tpl-layout,\n  .tpl-form-grid,\n  .tpl-pair,\n  .tpl-task-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tpl-summary {\n    position: static;\n  }\n}\n\n.plan-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));\n  gap: 1rem;\n}\n\n.plan-grid-wide {\n  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));\n}\n\n.plan-card h3 {\n  margin: 0 0 0.35rem;\n}\n\n.plan-card-current {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px #2563eb;\n}\n\n.plan-card-price {\n  margin: 0.5rem 0 0.75rem;\n}\n\n.plan-badge {\n  display: inline-block;\n  margin: 0 0 0.35rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.billing-page {\n  max-width: 56rem;\n}\n\n.current-plan-panel {\n  border-color: #2563eb;\n}\n\n.current-plan-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.current-plan-price {\n  text-align: right;\n}\n\n.plan-features {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.plan-feature-group-title {\n  margin: 0 0 0.25rem;\n  font-weight: 600;\n}\n\n.plan-feature-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.plan-feature-list li {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.plan-feature-label {\n  font-size: 0.9rem;\n}\n\n.plan-features-compact .plan-feature-list {\n  gap: 0.2rem;\n}\n\n.plan-features-compact .plan-feature-label {\n  font-size: 0.85rem;\n}\n\n.plan-feature-desc {\n  display: block;\n  line-height: 1.35;\n}\n\n.plan-card .plan-features {\n  flex: 1;\n  margin-bottom: 1rem;\n}\n\n.plan-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.list-plain {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.impersonation-banner {\n  position: sticky;\n  top: 0;\n  z-index: 1050;\n  background: linear-gradient(90deg, #b45309, #d97706);\n  color: #fffbeb;\n  border-bottom: 2px solid #92400e;\n  box-shadow: 0 2px 8px rgb(146 64 14 / 25%);\n}\n\n.impersonation-banner-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0.55rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  font-size: 0.95rem;\n}\n\n.impersonation-banner strong {\n  color: #fff;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.6rem;\n  font-size: 0.85rem;\n}\n\n.faq-viewer .faq-category {\n  margin-bottom: 2rem;\n}\n\n.faq-category-title {\n  font-size: 1.15rem;\n  margin: 0 0 0.75rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.faq-item-toggle {\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n}\n\n.faq-item-body {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--border);\n}\n\n.faq-credentials {\n  margin: 0.75rem 0;\n}\n\n.faq-credential-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 1rem;\n  margin: 0.5rem 0;\n}\n\n.faq-credential-label {\n  min-width: 5rem;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.faq-credential-value {\n  flex: 1;\n  min-width: 8rem;\n  padding: 0.35rem 0.5rem;\n  background: var(--surface-2, #f4f4f5);\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.faq-image img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 6px;\n}\n\n.faq-media-caption {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1rem;\n  margin-top: 0.35rem;\n  font-size: 0.85rem;\n}\n\n.faq-media-thumb {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-width: 0;\n}\n\n.faq-media-thumb img {\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.faq-media-thumb--file .faq-file-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  border-radius: 4px;\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.faq-media-name {\n  font-size: 0.85rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 14rem;\n}\n\n.faq-file-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  margin: 0.5rem 0;\n}\n\n.faq-file-card-thumb {\n  width: 56px;\n  height: 56px;\n  object-fit: cover;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.faq-file-icon--large {\n  font-size: 2rem;\n  line-height: 1;\n}\n\n.faq-file-card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.faq-file-card-name {\n  word-break: break-word;\n}\n\n.faq-block-list {\n  margin: 0.5rem 0 0;\n}\n\n.faq-block-list-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.faq-block-list-main {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.faq-block-type-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 0.15rem 0.45rem;\n  border-radius: 4px;\n}\n\n.faq-form {\n  max-width: 32rem;\n  margin: 1rem 0;\n}\n\n.faq-admin-category h3 {\n  font-size: 1.05rem;\n}\n\n.chat-widget-fab {\n  position: fixed;\n  right: 1.25rem;\n  bottom: 1.25rem;\n  z-index: 1000;\n  width: 3.25rem;\n  height: 3.25rem;\n  border: none;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 1.35rem;\n  cursor: pointer;\n  box-shadow: 0 4px 20px rgb(15 23 42 / 25%);\n}\n\n.chat-widget-fab:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.chat-widget-panel {\n  position: fixed;\n  right: 1.25rem;\n  bottom: 5rem;\n  z-index: 1000;\n  width: min(22rem, calc(100vw - 2rem));\n  max-height: min(32rem, calc(100vh - 6rem));\n  display: flex;\n  flex-direction: column;\n  padding: 0.75rem;\n  box-shadow: 0 8px 32px rgb(15 23 42 / 18%);\n}\n\n.chat-widget-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.chat-widget-panel .auth-card {\n  box-shadow: none;\n  border: none;\n  padding: 0;\n  min-height: auto;\n}\n\n.notif-prefs-table {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.notif-prefs-head,\n.notif-prefs-row {\n  display: grid;\n  grid-template-columns: 1fr 4rem 4rem;\n  gap: 0.75rem;\n  align-items: start;\n}\n\n.notif-prefs-head {\n  font-size: 0.85rem;\n  color: var(--muted, #64748b);\n  border-bottom: 1px solid rgb(15 23 42 / 10%);\n  padding-bottom: 0.35rem;\n}\n\n.notif-prefs-check {\n  display: flex;\n  justify-content: center;\n  margin: 0;\n}\n\n.notif-bell-item + .notif-bell-item {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgb(15 23 42 / 8%);\n}\n\n.workspace-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.75rem;\n}\n\n.workspace-tab {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n  border-radius: 999px;\n  padding: 0.35rem 0.85rem;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.workspace-tab.active {\n  background: #1d4ed8;\n  border-color: #1d4ed8;\n  color: #fff;\n}\n\n.badge {\n  display: inline-block;\n  font-size: 0.75rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.badge-ok {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.badge-warn {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.integration-requirements {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border, #e5e7eb);\n}\n\n.integration-requirements-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.75rem;\n}\n\n.integration-requirements-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.5rem;\n}\n\n.integration-requirements-item {\n  display: flex;\n  gap: 0.65rem;\n  align-items: flex-start;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid var(--border, #e5e7eb);\n  border-radius: 0.5rem;\n  background: #fafafa;\n}\n\n.integration-requirements-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.integration-requirements-title {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  font-size: 0.92rem;\n}\n\n.integration-requirements-meta {\n  color: #6b7280;\n  font-size: 0.75rem;\n}\n\n.integration-requirements-status {\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-top: 0.15rem;\n}\n\n.integration-requirements-optional-label {\n  margin: 0.85rem 0 0.45rem;\n}\n\n.integration-req-dot {\n  width: 0.55rem;\n  height: 0.55rem;\n  border-radius: 999px;\n  margin-top: 0.35rem;\n  flex-shrink: 0;\n}\n\n.integration-req-ok,\n.integration-req-dot.integration-req-ok {\n  color: #166534;\n}\n\n.integration-req-dot.integration-req-ok {\n  background: #22c55e;\n}\n\n.integration-req-missing,\n.integration-req-dot.integration-req-missing {\n  color: #6b7280;\n}\n\n.integration-req-dot.integration-req-missing {\n  background: #9ca3af;\n}\n\n.integration-req-denied,\n.integration-req-dot.integration-req-denied {\n  color: #b91c1c;\n}\n\n.integration-req-dot.integration-req-denied {\n  background: #ef4444;\n}\n\n.integration-req-skipped,\n.integration-req-dot.integration-req-skipped {\n  color: #92400e;\n}\n\n.integration-req-dot.integration-req-skipped {\n  background: #f59e0b;\n}\n\n.integration-req-error,\n.integration-req-dot.integration-req-error {\n  color: #b91c1c;\n}\n\n.integration-req-dot.integration-req-error {\n  background: #ef4444;\n}\n\n.integration-features-summary {\n  display: grid;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.integration-features-group {\n  padding: 0.65rem 0.75rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border, #e5e7eb);\n}\n\n.integration-features-available {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.integration-features-unavailable {\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n.integration-features-title {\n  margin: 0 0 0.35rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.integration-features-available .integration-features-title {\n  color: #166534;\n}\n\n.integration-features-unavailable .integration-features-title {\n  color: #991b1b;\n}\n\n.integration-features-list {\n  margin: 0;\n  padding-left: 1.1rem;\n  display: grid;\n  gap: 0.35rem;\n  font-size: 0.88rem;\n}\n\n.integration-features-list li {\n  display: grid;\n  gap: 0.1rem;\n}\n\n.integration-features-blockers {\n  display: block;\n}\n\n.integration-req-impact {\n  margin-top: 0.35rem;\n  font-size: 0.82rem;\n  line-height: 1.35;\n}\n\n.integration-req-impact-enabled {\n  color: #166534;\n}\n\n.integration-req-impact-blocked {\n  color: #991b1b;\n}\n\n.dashboard-integrations-card {\n  margin-top: 0;\n}\n\n.dashboard-integrations-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.85rem;\n}\n\n.dashboard-integrations-summary {\n  font-size: 0.8rem;\n  color: #6b7280;\n  background: #f3f4f6;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n}\n\n.dashboard-integrations-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.45rem;\n}\n\n.dashboard-integrations-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.5rem 0.65rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.55rem;\n  background: #fafafa;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.dashboard-integrations-item--full {\n  background: #f7fdf9;\n  border-color: #bbf7d0;\n}\n\n.dashboard-integrations-item--partial {\n  background: #fffbeb;\n  border-color: #fde68a;\n}\n\n.dashboard-integrations-item--none .dashboard-integrations-label {\n  color: #6b7280;\n}\n\n.dashboard-integrations-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n}\n\n.integration-status-icon {\n  width: 1.45rem;\n  height: 1.45rem;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 0.05rem;\n}\n\n.integration-status-icon--ok {\n  background: linear-gradient(145deg, #22c55e, #16a34a);\n  color: #fff;\n  box-shadow: 0 1px 4px rgb(22 163 74 / 28%);\n}\n\n.integration-status-icon--partial {\n  background: linear-gradient(145deg, #f59e0b, #d97706);\n  color: #fff;\n  box-shadow: 0 1px 4px rgb(217 119 6 / 28%);\n}\n\n.integration-status-icon--missing {\n  background: #f3f4f6;\n  color: #9ca3af;\n  border: 1px solid #e5e7eb;\n}\n\n.dashboard-integrations-label {\n  font-size: 0.9rem;\n  color: #1f2937;\n  line-height: 1.25;\n}\n\n.dashboard-integrations-item--partial .dashboard-integrations-label {\n  color: #92400e;\n}\n\n.dashboard-integrations-hint {\n  font-size: 0.72rem;\n  line-height: 1.25;\n  color: #b45309;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dashboard-integrations-link {\n  display: inline-block;\n  margin-top: 0.85rem;\n}\n\n/* Activity / audit log */\n.audit-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n  flex-wrap: wrap;\n}\n\n.audit-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 0.65rem 1rem;\n  background: linear-gradient(145deg, #f8fafc 0%, #eef2ff 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  min-width: 5.5rem;\n}\n\n.audit-stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #0f172a;\n}\n\n.audit-stat-label {\n  font-size: 0.75rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.audit-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 1.25rem;\n  padding: 0.85rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  max-width: none;\n}\n\n.audit-filters.search-form .form-control,\n.audit-filters.search-form .form-select {\n  flex: 0 1 auto;\n  min-width: 9rem;\n  max-width: 16rem;\n  border-radius: 0.375rem;\n  border-right: 1px solid #ced4da;\n  margin-right: 0;\n}\n\n.audit-filters.search-form .form-control[type='date'] {\n  min-width: 9.5rem;\n}\n\n.audit-filters.search-form .btn-secondary,\n.audit-filters.search-form .btn-primary {\n  border-radius: 0.375rem;\n}\n\n.audit-filters.search-form:focus-within .form-control {\n  border-right: 1px solid #ced4da;\n  margin-right: 0;\n  z-index: auto;\n}\n\n.audit-empty {\n  text-align: center;\n  padding: 2.5rem 1.5rem;\n  background: #fff;\n  border: 1px dashed #cbd5e1;\n  border-radius: 0.75rem;\n}\n\n.audit-empty-title {\n  margin: 0 0 0.35rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.audit-feed {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.audit-item {\n  display: flex;\n  gap: 0.85rem;\n  padding: 1rem 1.1rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.audit-item:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.audit-avatar {\n  flex: 0 0 2.5rem;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #1e3a5f;\n  background: #e2e8f0;\n}\n\n.audit-item-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.audit-item-top {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  align-items: baseline;\n  flex-wrap: wrap;\n  margin-bottom: 0.35rem;\n}\n\n.audit-when {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.1rem;\n  white-space: nowrap;\n}\n\n.audit-when-rel {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.audit-what {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.25rem;\n}\n\n.audit-action {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.audit-badge {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.audit-summary {\n  margin: 0.15rem 0 0.35rem;\n  font-size: 0.9rem;\n}\n\n.audit-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.audit-details-toggle {\n  padding: 0.1rem 0.35rem;\n  font-size: 0.8rem;\n}\n\n.audit-details {\n  margin: 0.65rem 0 0;\n  padding: 0.65rem 0.75rem;\n  background: #f8fafc;\n  border-radius: 0.5rem;\n  border: 1px solid #e2e8f0;\n}\n\n.audit-detail-row {\n  display: grid;\n  grid-template-columns: minmax(6rem, 9rem) 1fr;\n  gap: 0.5rem;\n  padding: 0.25rem 0;\n  font-size: 0.85rem;\n}\n\n.audit-detail-row dt {\n  margin: 0;\n  color: #64748b;\n  text-transform: capitalize;\n}\n\n.audit-detail-row dd {\n  margin: 0;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.audit-cat-clients {\n  background: #dbeafe;\n  color: #1e40af;\n}\n.audit-cat-projects {\n  background: #dcfce7;\n  color: #166534;\n}\n.audit-cat-tasks {\n  background: #ffedd5;\n  color: #9a3412;\n}\n.audit-cat-team {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n.audit-cat-integrations {\n  background: #e0f2fe;\n  color: #075985;\n}\n.audit-cat-org {\n  background: #f1f5f9;\n  color: #334155;\n}\n.audit-cat-billing {\n  background: #fef3c7;\n  color: #92400e;\n}\n.audit-cat-security {\n  background: #fee2e2;\n  color: #991b1b;\n}\n.audit-cat-docs,\n.audit-cat-assets {\n  background: #fce7f3;\n  color: #9d174d;\n}\n.audit-cat-other {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n.audit-avatar.audit-cat-clients,\n.audit-avatar.audit-cat-projects,\n.audit-avatar.audit-cat-tasks,\n.audit-avatar.audit-cat-team,\n.audit-avatar.audit-cat-integrations,\n.audit-avatar.audit-cat-org,\n.audit-avatar.audit-cat-billing,\n.audit-avatar.audit-cat-security,\n.audit-avatar.audit-cat-docs,\n.audit-avatar.audit-cat-assets,\n.audit-avatar.audit-cat-other {\n  border: none;\n}\n\n@media (max-width: 720px) {\n  .audit-filters .form-control,\n  .audit-filters .form-select {\n    max-width: none;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .audit-detail-row {\n    grid-template-columns: 1fr;\n    gap: 0.1rem;\n  }\n\n  .audit-when {\n    align-items: flex-start;\n  }\n}\n\n/* PDF editor */\n.page-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n/* Full-viewport editor workspace (fixed to the screen — not % of a relative parent). */\n.pdf-editor-layout {\n  position: fixed !important;\n  top: var(--pdf-editor-inset-top, 0px) !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  z-index: 40;\n  box-sizing: border-box;\n  width: auto !important;\n  max-width: none !important;\n  height: auto !important;\n  min-height: 0 !important;\n  margin: 0 !important;\n  padding: 0.65rem 1.25rem 0.75rem;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0;\n  overflow: hidden !important;\n  background: #eef2f7;\n}\n\nhtml.pdf-editor-page-active,\nhtml.pdf-editor-page-active body,\nbody.pdf-editor-page-active {\n  height: 100%;\n  overflow: hidden !important;\n}\n\nbody.pdf-editor-page-active .dashboard {\n  min-height: 0 !important;\n  height: 100dvh !important;\n  max-height: 100dvh !important;\n  overflow: hidden !important;\n}\n\nbody.pdf-editor-page-active .dashboard-header {\n  position: relative;\n  z-index: 50;\n  flex: 0 0 auto;\n}\n\n/* Outlet is taken out of flow by the fixed editor — keep main from creating a gray band. */\nbody.pdf-editor-page-active .dashboard-main {\n  display: block !important;\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  height: auto !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.pdf-editor-layout .page-header-row {\n  flex: 0 0 auto;\n  margin-bottom: 0.55rem;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.pdf-editor-layout .page-header-row h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  line-height: 1.25;\n}\n\n.pdf-editor-layout .page-header-row > div > .muted.small:last-child {\n  display: none;\n}\n\n.pdf-editor-layout .page-header-row > div > .pdf-editor-size-line {\n  display: block !important;\n  margin: 0.15rem 0 0;\n}\n\n.pdf-editor-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.pdf-editor-size-box {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid var(--border, #dbe1ea);\n  border-radius: 8px;\n  background: var(--surface-2, #f7f9fc);\n}\n\n.pdf-editor-size-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  font-size: 0.86rem;\n}\n\n.pdf-editor-size-row span {\n  color: var(--muted, #64748b);\n}\n\n/* Editor left + settings column right */\n.pdf-editor-grid {\n  display: flex !important;\n  flex-direction: row !important;\n  flex-wrap: nowrap !important;\n  align-items: stretch !important;\n  gap: 0.85rem;\n  width: 100%;\n  flex: 1 1 0 !important;\n  min-height: 0 !important;\n  height: auto !important;\n  overflow: hidden;\n}\n\n.pdf-editor-main {\n  flex: 1 1 0 !important;\n  width: auto !important;\n  max-width: none !important;\n  min-width: 0 !important;\n  min-height: 0 !important;\n  height: auto !important;\n}\n\n.pdf-editor-sidebar {\n  flex: 0 0 300px !important;\n  width: 300px !important;\n  max-width: 300px !important;\n  min-width: 300px !important;\n  min-height: 0 !important;\n  height: auto !important;\n  align-self: stretch;\n  overflow: auto;\n  overscroll-behavior: contain;\n  margin-top: 0 !important;\n}\n\n.pdf-editor-sidebar .field {\n  margin-bottom: 0.65rem;\n}\n\n.pdf-margin-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.45rem;\n  margin-top: 0.35rem;\n}\n\n.pdf-margin-field,\n.pdf-margin-all {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.8rem;\n  color: #475569;\n}\n\n.pdf-margin-field input,\n.pdf-margin-all input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.35rem 0.45rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.4rem;\n  font-size: 0.9rem;\n}\n\n.pdf-margin-all {\n  margin-top: 0.45rem;\n}\n\n.pdf-editor-layout > .err,\n.pdf-editor-layout > .ok {\n  flex: 0 0 auto;\n  margin: 0 0 0.5rem;\n}\n\n.pdf-editor-sidebar .auth-card.flat {\n  max-width: none !important;\n  width: 100% !important;\n  box-sizing: border-box;\n}\n\n.pdf-editor-main.auth-card.flat {\n  padding: 0 !important;\n  overflow: hidden;\n  background: transparent !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  max-width: none !important;\n  width: auto !important;\n  min-height: 0 !important;\n  height: auto !important;\n  flex: 1 1 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n/* Word-like document shell — flex-sized, not height:100% of a relative parent */\n.pdf-word-shell {\n  position: relative;\n  background: #c5cad3;\n  border: 1px solid #c5ccd6;\n  border-radius: 10px;\n  overflow: hidden;\n  width: 100%;\n  flex: 1 1 0;\n  min-height: 0;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);\n}\n\n.pdf-word-titlebar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 38px;\n  flex-shrink: 0;\n  padding: 0 14px;\n  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);\n  border-bottom: 1px solid #cfd6e0;\n}\n\n.pdf-word-titlebar-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #c4c9d2;\n}\n\n.pdf-word-titlebar-dot:nth-child(1) { background: #ff5f57; }\n.pdf-word-titlebar-dot:nth-child(2) { background: #febc2e; }\n.pdf-word-titlebar-dot:nth-child(3) { background: #28c840; }\n\n.pdf-word-titlebar-name {\n  margin-left: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.pdf-word-zoom {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.pdf-word-zoom-btn {\n  width: 26px;\n  height: 26px;\n  border: 1px solid #c5ccd6;\n  border-radius: 6px;\n  background: #fff;\n  color: #334155;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n}\n\n.pdf-word-zoom-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.pdf-word-zoom-btn:not(:disabled):hover {\n  background: #f8fafc;\n  border-color: #94a3b8;\n}\n\n.pdf-word-zoom-select {\n  height: 26px;\n  border: 1px solid #c5ccd6;\n  border-radius: 6px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 0 6px;\n  cursor: pointer;\n}\n\n.pdf-word-textarea-seed {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n  left: -9999px !important;\n  border: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.pdf-word-editor-host {\n  flex: 1 1 0;\n  min-height: 0;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.pdf-word-shell .tox-tinymce {\n  border: 0 !important;\n  border-radius: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n}\n\n/* TinyMCE fullscreen must own the real viewport — escape parent stacking contexts. */\n.tox.tox-tinymce.tox-fullscreen,\n.tox-tinymce.tox-fullscreen,\n.tox-fullscreen .tox-tinymce {\n  position: fixed !important;\n  inset: 0 !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  max-width: none !important;\n  max-height: none !important;\n  min-width: 100vw !important;\n  min-height: 100vh !important;\n  z-index: 2147483000 !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: #ffffff !important;\n  display: flex !important;\n  flex-direction: column !important;\n  pointer-events: auto !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\nbody.tox-fullscreen,\nhtml.tox-fullscreen {\n  overflow: hidden !important;\n}\n\n/* Parent layout stacking context (z-index:40) trapped TinyMCE under the site header (50).\n   Raise + expand the editor shell above chrome while FS is on — never reparent the iframe. */\nbody.tox-fullscreen .pdf-editor-layout {\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  z-index: 2147482900 !important;\n  padding: 0 !important;\n  background: #c5cad3 !important;\n}\n\nbody.tox-fullscreen .pdf-editor-layout .page-header-row,\nbody.tox-fullscreen .pdf-editor-layout .pdf-editor-sidebar,\nbody.tox-fullscreen .pdf-editor-layout > .err,\nbody.tox-fullscreen .pdf-editor-layout > .ok {\n  display: none !important;\n}\n\nbody.tox-fullscreen .pdf-editor-layout .pdf-editor-grid,\nbody.tox-fullscreen .pdf-editor-layout .pdf-editor-main,\nbody.tox-fullscreen .pdf-editor-layout .pdf-word-shell,\nbody.tox-fullscreen .pdf-editor-layout .pdf-word-editor-host {\n  position: absolute !important;\n  inset: 0 !important;\n  width: auto !important;\n  height: auto !important;\n  max-width: none !important;\n  min-width: 0 !important;\n  min-height: 0 !important;\n  margin: 0 !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  overflow: hidden !important;\n  pointer-events: auto !important;\n  background: transparent !important;\n}\n\nbody.tox-fullscreen .pdf-editor-layout .pdf-word-titlebar {\n  display: none !important;\n}\n\nbody.tox-fullscreen .pdf-editor-layout .tox-tinymce,\nbody.tox-fullscreen .pdf-editor-layout .tox-tinymce.tox-fullscreen {\n  pointer-events: auto !important;\n}\n\nbody.tox-fullscreen .dashboard-header,\nbody.tox-fullscreen .impersonation-banner,\nbody.tox-fullscreen .impersonation-banner-inner,\nbody.tox-fullscreen .portal-preview-banner {\n  z-index: 0 !important;\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\n/* Keep document pages visible inside the FS iframe */\nbody.tox-fullscreen .tox-edit-area__iframe {\n  background: #c5cad3 !important;\n}\n\n.tox-tinymce.tox-fullscreen .tox-editor-header {\n  display: grid !important;\n  grid-template-columns: 1fr min-content !important;\n  flex: 0 0 auto !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  background: #ffffff !important;\n  box-shadow: 0 1px 0 #d5dbe5 !important;\n  padding: 4px 0 !important;\n  position: relative !important;\n  z-index: 5 !important;\n}\n\n.tox-tinymce.tox-fullscreen .tox-menubar,\n.tox-tinymce.tox-fullscreen .tox-toolbar-overlord,\n.tox-tinymce.tox-fullscreen .tox-toolbar__primary,\n.tox-tinymce.tox-fullscreen .tox-toolbar__overflow,\n.tox-tinymce.tox-fullscreen .tox-toolbar {\n  display: flex !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  height: auto !important;\n  max-height: none !important;\n  pointer-events: auto !important;\n}\n\n.tox-tinymce.tox-fullscreen .tox-sidebar-wrap {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.tox-tinymce.tox-fullscreen .tox-edit-area {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  height: auto !important;\n  display: flex !important;\n}\n\n.tox-tinymce.tox-fullscreen .tox-edit-area__iframe {\n  flex: 1 1 auto !important;\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 0 !important;\n}\n\n.tox-tinymce.tox-fullscreen .tox-statusbar {\n  display: flex !important;\n  visibility: visible !important;\n  flex: 0 0 auto !important;\n}\n\n.pdf-word-shell .tox-editor-header {\n  background: #f3f5f8 !important;\n  box-shadow: inset 0 -1px 0 #d5dbe5 !important;\n  padding: 4px 6px 2px !important;\n}\n\n.pdf-word-shell .tox-menubar,\n.pdf-word-shell .tox-toolbar-overlord,\n.pdf-word-shell .tox-toolbar__primary {\n  background: transparent !important;\n}\n\n.pdf-word-shell .tox-statusbar {\n  background: #f8fafc !important;\n  border-top: 1px solid #d5dbe5 !important;\n}\n\n.pdf-word-shell .tox-edit-area__iframe {\n  background: #edf0f4 !important;\n}\n\n.pdf-word-shell:not(.is-ready) .tox-tinymce {\n  opacity: 0;\n}\n\n.pdf-word-loading {\n  position: absolute;\n  inset: 38px 0 0;\n  display: grid;\n  place-items: center;\n  background:\n    radial-gradient(circle at top, rgba(255,255,255,.55), transparent 45%),\n    #e5e9ef;\n  z-index: 2;\n}\n\n.pdf-word-loading-card {\n  width: min(420px, calc(100% - 48px));\n  background: #fff;\n  border: 1px solid #d7dde7;\n  border-radius: 12px;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.1);\n  padding: 28px 24px;\n  text-align: center;\n}\n\n.pdf-word-loading-card p {\n  margin: 14px 0 0;\n  color: #475569;\n  font-size: 0.95rem;\n}\n\n.pdf-word-loading-spinner {\n  width: 34px;\n  height: 34px;\n  margin: 0 auto;\n  border-radius: 50%;\n  border: 3px solid #dbe3ef;\n  border-top-color: #2563eb;\n  animation: pdf-word-spin 0.8s linear infinite;\n}\n\n@keyframes pdf-word-spin {\n  to { transform: rotate(360deg); }\n}\n\n.pdf-word-error {\n  margin: 48px auto;\n  max-width: 480px;\n  background: #fff;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.pdf-preview-frame {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  border: 1px solid #c5ccd6;\n  border-radius: 10px;\n  background: #edf0f4;\n}\n\n.pdf-html-preview {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  border: 1px solid #c5ccd6;\n  border-radius: 10px;\n  background: #fff;\n  overflow: auto;\n}\n\n.pdf-html-preview-doc {\n  width: 100%;\n  max-width: none;\n  box-sizing: border-box;\n  padding: 32px 40px 56px;\n  font-family: Calibri, Candara, Segoe, \"Segoe UI\", Optima, Arial, sans-serif;\n  font-size: 11pt;\n  line-height: 1.5;\n  color: #111827;\n}\n\n.pdf-html-preview-doc h1 { font-size: 24pt; line-height: 1.25; margin: 0 0 14pt; font-weight: 700; }\n.pdf-html-preview-doc h2 { font-size: 16pt; line-height: 1.3; margin: 18pt 0 10pt; font-weight: 700; }\n.pdf-html-preview-doc h3 { font-size: 13pt; line-height: 1.35; margin: 14pt 0 8pt; font-weight: 700; }\n.pdf-html-preview-doc p { margin: 0 0 10pt; }\n.pdf-html-preview-doc ul,\n.pdf-html-preview-doc ol { margin: 0 0 10pt; padding-left: 24pt; }\n.pdf-html-preview-doc li { margin: 0 0 4pt; }\n.pdf-html-preview-doc img { max-width: 100%; height: auto; }\n.pdf-html-preview-doc table { width: 100%; border-collapse: collapse; margin: 12pt 0; }\n.pdf-html-preview-doc td,\n.pdf-html-preview-doc th { border: 1px solid #9ca3af; padding: 6pt 8pt; vertical-align: top; }\n\n.pdf-editor-pages {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.pdf-editor-page-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.pdf-editor-page-label {\n  font-size: 0.8rem;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.pdf-editor-page {\n  position: relative;\n  margin: 0 auto;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.pdf-editor-page canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.pdf-editor-page.tool-text,\n.pdf-editor-page.tool-image {\n  cursor: crosshair;\n}\n\n.pdf-overlay {\n  position: absolute;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px dashed #94a3b8;\n  border-radius: 4px;\n  padding: 2px;\n  box-sizing: border-box;\n  cursor: move;\n  touch-action: none;\n}\n\n.pdf-overlay.is-image {\n  background: transparent;\n  padding: 0;\n  overflow: hidden;\n}\n\n.pdf-overlay.is-image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  pointer-events: none;\n  user-select: none;\n}\n\n.pdf-overlay-image-empty {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  height: 100%;\n  min-height: 48px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.pdf-overlay.is-selected {\n  border-color: #2563eb;\n  background: rgba(219, 234, 254, 0.85);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.pdf-overlay.is-image.is-selected {\n  background: transparent;\n}\n\n.pdf-overlay textarea {\n  width: 100%;\n  min-height: 48px;\n  border: 0;\n  background: transparent;\n  resize: vertical;\n  font: inherit;\n  color: inherit;\n  line-height: 1.25;\n  padding: 0.15rem;\n  cursor: text;\n}\n\n.pdf-overlay-remove {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: 0;\n  background: #dc2626;\n  color: #fff;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.pdf-overlay-resize {\n  position: absolute;\n  right: -6px;\n  bottom: -6px;\n  width: 14px;\n  height: 14px;\n  border-radius: 2px;\n  background: #2563eb;\n  border: 2px solid #fff;\n  cursor: nwse-resize;\n  z-index: 3;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.25);\n}\n\n.ok {\n  color: #047857;\n  font-size: 0.92rem;\n}\n\n.pm2-logs-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem;\n}\n\n.pm2-logs-controls .field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.pm2-logs-type {\n  min-width: 8rem;\n  width: 8rem;\n}\n\n.pm2-logs-controls .pm2-logs-load {\n  align-self: flex-end;\n}\n\n.pm2-system-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 0.75rem 1rem;\n  margin-top: 1rem;\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--bs-border-color, #dee2e6);\n  border-radius: 8px;\n  background: var(--bs-tertiary-bg, #f8f9fa);\n}\n\n.pm2-system-metrics > div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.pm2-system-metrics strong {\n  font-size: 0.95rem;\n}\n\n.pm2-sort-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.pm2-sort-btn:hover {\n  color: #0f172a;\n}\n\n.pm2-sort-indicator {\n  font-size: 0.65rem;\n  line-height: 1;\n  opacity: 0.35;\n}\n\n.pm2-sort-btn.is-active .pm2-sort-indicator {\n  opacity: 1;\n}\n\n.docker-projects {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.docker-project {\n  border: 1px solid var(--bs-border-color, #dee2e6);\n  border-radius: 8px;\n  background: var(--bs-body-bg, #fff);\n  overflow: hidden;\n}\n\n.docker-project-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem 1rem;\n  padding: 0.75rem 0.9rem;\n  background: var(--bs-tertiary-bg, #f8f9fa);\n}\n\n.docker-project-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  flex: 1 1 220px;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n  color: inherit;\n}\n\n.docker-project-chevron {\n  width: 1rem;\n  color: var(--bs-secondary-color, #6c757d);\n}\n\n.docker-project-name {\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.docker-project-meta {\n  display: inline-flex;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n}\n\n.docker-project-actions {\n  margin-left: auto;\n}\n\n.docker-project-containers {\n  border-top: 1px solid var(--bs-border-color, #dee2e6);\n  margin: 0;\n}\n\n.docker-project-containers .data-table {\n  margin: 0;\n}\n\n.npm-script-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding: 0.75rem 0.9rem 0.9rem;\n  border-top: 1px solid var(--bs-border-color, #dee2e6);\n}\n\n.npm-script-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.npm-script-copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.npm-script-copy code {\n  color: var(--bs-secondary-color, #6c757d);\n  font-size: 0.78rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.npm-script-output {\n  margin: 0.35rem 0 0;\n  max-height: 320px;\n  overflow: auto;\n  background: var(--bs-tertiary-bg, #f8f9fa);\n  padding: 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  white-space: pre-wrap;\n}\n\n.npm-kind {\n  margin-left: 0.45rem;\n  padding: 0.05rem 0.4rem;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #475569;\n  background: #e2e8f0;\n}\n\n.npm-kind-engine {\n  color: #5b21b6;\n  background: #ede9fe;\n}\n\n.npm-kind-site {\n  color: #1d4ed8;\n  background: #dbeafe;\n}\n\n.npm-site-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.npm-stage {\n  padding: 0.05rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.npm-stage-live {\n  color: #166534;\n  background: #dcfce7;\n}\n\n.npm-stage-staging {\n  color: #854d0e;\n  background: #fef9c3;\n}\n\n.npm-stage-down {\n  color: #991b1b;\n  background: #fee2e2;\n}\n\n.npm-site-link {\n  max-width: 16rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.8rem;\n}\n\n.npm-version-row {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-left: auto;\n}\n\n.npm-version-chip,\n.npm-version-btn {\n  border-radius: 999px;\n  padding: 0.2rem 0.6rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  line-height: 1.3;\n}\n\n.npm-version-chip.is-latest {\n  color: #1d4ed8;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n}\n\n.npm-version-chip.is-stuck {\n  color: #b91c1c;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n}\n\n.npm-version-btn {\n  cursor: pointer;\n}\n\n.npm-version-btn.is-behind {\n  color: #fff;\n  background: #dc2626;\n  border: 1px solid #b91c1c;\n}\n\n.npm-version-btn:disabled {\n  opacity: 0.7;\n  cursor: progress;\n}\n\n.npm-script-block + .npm-script-block {\n  padding-top: 0.65rem;\n  border-top: 1px solid var(--bs-border-color, #e9ecef);\n}\n\n.npm-script-form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem 0.75rem;\n  align-items: end;\n  margin-top: 0.55rem;\n}\n\n.npm-script-form .field {\n  margin: 0;\n  min-width: 11rem;\n  flex: 1 1 11rem;\n}\n\n.npm-script-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-height: 2.1rem;\n  font-size: 0.85rem;\n}\n\n.npm-script-check code,\n.npm-script-preview code {\n  font-size: 0.75rem;\n}\n\n.npm-script-preview {\n  margin: 0.35rem 0 0;\n}\n\n.integrations-table-row {\n  cursor: pointer;\n}\n\n.integrations-table-row:hover > td {\n  background: var(--bs-tertiary-bg, #f8f9fa);\n}\n\n.integrations-table-row:focus-visible {\n  outline: 2px solid var(--bs-primary, #0d6efd);\n  outline-offset: -2px;\n}\n\n.integrations-table-summary {\n  max-width: 28rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.integration-editor .stack {\n  gap: 0.85rem;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  margin-top: 0.75rem;\n}\n\n@media (max-width: 720px) {\n  .pdf-editor-layout {\n    padding: 0.5rem 0.75rem 0.65rem;\n  }\n\n  .pdf-editor-grid {\n    flex-direction: column !important;\n    overflow: auto;\n  }\n\n  .pdf-editor-sidebar {\n    flex: 0 0 auto !important;\n    width: 100% !important;\n    max-width: none !important;\n    min-width: 0 !important;\n    height: auto !important;\n    max-height: 38vh;\n  }\n\n  .pdf-word-shell,\n  .pdf-editor-main.auth-card.flat {\n    min-height: 52vh;\n  }\n}\n\n.task-board {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  overflow-x: auto;\n  padding: 0.25rem 0.15rem 1rem;\n  margin-top: 0.75rem;\n}\n\n.task-column {\n  flex: 0 0 18.5rem;\n  width: 18.5rem;\n  max-height: calc(100vh - 13rem);\n  display: flex;\n  flex-direction: column;\n  background: var(--stage-wash, #f1f2f4);\n  border-radius: 0.75rem;\n}\n\n.task-column.is-drop {\n  background: var(--stage-wash-strong, #e4e6ea);\n}\n\n.task-column-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.7rem 0.75rem 0.35rem;\n}\n\n.task-column-title {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  min-width: 0;\n}\n\n.task-column-head .task-column-mark {\n  flex: 0 0 1.35rem;\n  width: 1.35rem;\n  height: 1.35rem;\n  color: var(--stage-color, #64748b);\n}\n\n.task-column-mark svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.task-column-head .task-column-count {\n  min-width: 1.4rem;\n  height: 1.4rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: rgb(255 255 255 / 72%);\n  color: #44546f;\n  font-size: 0.75rem;\n  font-weight: 650;\n}\n\n.task-column-head h3 {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 650;\n}\n\n.task-column-progress {\n  margin: 0.1rem 0 0;\n  color: #626f86;\n  font-size: 0.75rem;\n}\n\n.task-card-weight {\n  display: inline-block;\n  margin-top: 0.35rem;\n  color: #626f86;\n  font-size: 0.75rem;\n}\n\n.task-stage-toolbar,\n.task-stage-editor {\n  margin-top: 0.75rem;\n}\n\n.task-stage-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.task-stage-toolbar p {\n  margin: 0;\n}\n\n.task-stage-editor {\n  padding: 0.9rem 1rem 1rem;\n  border-radius: 0.75rem;\n  background: #fff;\n  box-shadow: 0 1px 2px rgb(15 23 42 / 8%);\n}\n\n.task-stage-editor-head,\n.task-stage-editor-actions {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.task-stage-editor-head h3 {\n  margin: 0 0 0.25rem;\n  font-size: 1rem;\n}\n\n.task-stage-editor-head p {\n  margin: 0;\n  max-width: 42rem;\n}\n\n.task-stage-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  margin: 0.85rem 0;\n}\n\n.task-stage-row {\n  display: grid;\n  grid-template-columns: minmax(9rem, 1.4fr) auto 6rem auto auto auto auto;\n  gap: 0.65rem;\n  align-items: end;\n  padding-bottom: 0.65rem;\n  border-bottom: 1px solid #e6e8ec;\n}\n\n.task-stage-swatches {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 2.4rem;\n}\n\n.task-stage-swatches button {\n  width: 1.35rem;\n  height: 1.35rem;\n  padding: 0;\n  border: 2px solid #fff;\n  border-radius: 999px;\n  box-shadow: 0 0 0 1px #d0d5dd;\n  cursor: pointer;\n}\n\n.task-stage-swatches button.is-selected,\n.task-stage-swatches button:focus-visible {\n  box-shadow: 0 0 0 2px var(--primary, #4f46e5);\n}\n\n.task-stage-swatches input[type='color'] {\n  width: 1.7rem;\n  height: 1.7rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.task-stage-check {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-bottom: 0.45rem;\n  font-size: 0.85rem;\n}\n\n.task-stage-row-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-bottom: 0.15rem;\n}\n\n.weight-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.4rem;\n}\n\n.weight-presets button {\n  border: 1px solid #d0d5dd;\n  border-radius: 999px;\n  padding: 0.15rem 0.55rem;\n  background: #fff;\n  font-size: 0.75rem;\n}\n\n.weight-presets button.is-selected {\n  border-color: var(--primary, #3b5bdb);\n  color: var(--primary, #3b5bdb);\n}\n\n@media (max-width: 900px) {\n  .task-stage-row {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.task-column-head span {\n  color: #626f86;\n  font-size: 0.8rem;\n}\n\n.task-column-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  overflow-y: auto;\n  min-height: 0.5rem;\n  padding: 0.35rem 0.5rem 0.15rem;\n}\n\n.task-card {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0.65rem 0.7rem;\n  border: none;\n  border-radius: 0.5rem;\n  background: #fff;\n  box-shadow: 0 1px 1px rgb(9 30 66 / 25%);\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.task-card:hover {\n  background: #f7f8f9;\n}\n\n.task-card.is-dragging {\n  opacity: 0.45;\n}\n\n.task-card-title {\n  display: block;\n  font-size: 0.92rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.task-card-project,\n.task-card-preview {\n  display: -webkit-box;\n  margin-top: 0.3rem;\n  overflow: hidden;\n  color: #626f86;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  white-space: pre-wrap;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.task-card-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.5rem;\n}\n\n.task-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.1rem 0.4rem;\n  border-radius: 0.3rem;\n  background: #f1f2f4;\n  color: #44546f;\n  font-size: 0.75rem;\n}\n\n.task-chip.is-overdue,\n.task-chip.is-urgent {\n  background: #ffebe6;\n  color: #ae2e24;\n}\n\n.task-chip.is-high {\n  background: #fff3eb;\n  color: #c25100;\n}\n\n.task-chip.is-medium {\n  background: #e9f2ff;\n  color: #0c66e4;\n}\n\n.task-chip.is-waiting {\n  background: #fff7d6;\n  color: #7f5f01;\n}\n\n.task-chip.is-request {\n  background: #e3fcef;\n  color: #216e4e;\n}\n\n.task-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem 0.85rem;\n  margin-top: 0.85rem;\n}\n\n.task-view-toggle,\n.task-quick-filters,\n.task-filter-selects {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.task-view-toggle button,\n.task-quick-filters button {\n  border: 1px solid #d0d5dd;\n  border-radius: 999px;\n  padding: 0.2rem 0.7rem;\n  background: #fff;\n  color: #344054;\n  font: inherit;\n  font-size: 0.82rem;\n  cursor: pointer;\n}\n\n.task-view-toggle button.is-selected,\n.task-quick-filters button.is-selected {\n  border-color: var(--primary, #3b5bdb);\n  background: #eef2ff;\n  color: var(--primary, #3b5bdb);\n}\n\n.task-filter-selects select {\n  border: 1px solid #d0d5dd;\n  border-radius: 0.45rem;\n  padding: 0.28rem 0.45rem;\n  background: #fff;\n  font: inherit;\n  font-size: 0.82rem;\n}\n\n.task-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.15rem;\n  margin-top: 0.85rem;\n}\n\n.task-list h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin: 0 0 0.45rem;\n  font-size: 0.95rem;\n}\n\n.task-list h3 span,\n.task-card-assignee {\n  color: #626f86;\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n\n.task-card-assignee.is-empty {\n  font-style: italic;\n}\n\n.task-list-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.task-checklist {\n  list-style: none;\n  margin: 0 0 0.5rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.task-checklist li {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.task-checklist input[type='text'],\n.task-checklist li > input:not([type='checkbox']) {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #d0d5dd;\n  border-radius: 0.4rem;\n  padding: 0.35rem 0.5rem;\n  font: inherit;\n}\n\n.task-checklist .is-done {\n  text-decoration: line-through;\n  color: #626f86;\n}\n\n.task-more {\n  position: relative;\n}\n\n.task-more-menu {\n  position: absolute;\n  z-index: 5;\n  top: calc(100% + 0.25rem);\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding: 0.35rem;\n  border-radius: 0.55rem;\n  background: #fff;\n  box-shadow: 0 8px 24px rgb(15 23 42 / 16%);\n}\n\n.task-more-menu > button {\n  border: none;\n  border-radius: 0.35rem;\n  background: transparent;\n  padding: 0.4rem 0.5rem;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n}\n\n.task-more-menu > button:hover {\n  background: #f1f2f4;\n}\n\n.task-more-menu .is-danger {\n  color: #ae2e24;\n}\n\n.task-waiting-dialog {\n  width: min(26rem, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.task-waiting-dialog h3 {\n  margin: 0;\n}\n\n.task-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 999px;\n  background: #172b4d;\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n}\n\n.task-card-meta .task-avatar {\n  margin-left: auto;\n}\n\n.task-add,\n.task-composer-cancel {\n  border: none;\n  background: transparent;\n  color: #44546f;\n  cursor: pointer;\n}\n\n.task-add {\n  margin: 0.15rem 0.5rem 0.5rem;\n  padding: 0.45rem 0.55rem;\n  border-radius: 0.5rem;\n  text-align: left;\n  font: inherit;\n}\n\n.task-add:hover,\n.task-composer-cancel:hover {\n  background: #dcdfe4;\n}\n\n.task-composer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin: 0.15rem 0.5rem 0.5rem;\n}\n\n.task-composer textarea,\n.task-composer select,\n.task-dialog textarea,\n.task-dialog-title {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.45rem;\n  background: #fff;\n  color: #0f172a;\n  font: inherit;\n}\n\n.task-composer textarea,\n.task-dialog textarea {\n  padding: 0.55rem 0.65rem;\n  resize: vertical;\n}\n\n.task-composer select {\n  padding: 0.45rem 0.55rem;\n}\n\n.task-composer-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.task-composer-cancel {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.35rem;\n  font-size: 1.25rem;\n  line-height: 1;\n}\n\n.task-dialog {\n  position: relative;\n  width: min(52rem, 100%);\n  max-height: calc(100vh - 2.5rem);\n  overflow: auto;\n  padding: 1.25rem 1.25rem 1.4rem;\n  border-radius: 0.75rem;\n  background: #fff;\n  box-shadow: 0 16px 48px rgb(15 23 42 / 20%);\n}\n\n.task-dialog-close {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n}\n\n.task-dialog-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 16rem;\n  gap: 1.25rem;\n}\n\n.task-dialog-title {\n  margin: 0 2rem 0 0;\n  padding: 0.35rem 0.5rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\nh3.task-dialog-title {\n  border: none;\n  padding-left: 0;\n}\n\n.task-dialog-kicker {\n  margin: 0.35rem 0 1rem;\n}\n\n.task-dialog-main h4 {\n  margin: 0 0 0.4rem;\n  font-size: 0.95rem;\n}\n\n.task-dialog-side {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.75rem;\n  padding-top: 2.4rem;\n}\n\n.task-dialog-side .btn-primary,\n.task-dialog-side .btn-link,\n.task-dialog-side .btn-secondary,\n.task-dialog-side .btn-danger {\n  width: 100%;\n  text-align: center;\n}\n\n.task-delete-confirm p {\n  margin: 0;\n  font-size: 0.85rem;\n}\n\n@media (max-width: 800px) {\n  .task-dialog-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .task-dialog-side {\n    padding-top: 0;\n  }\n}\n\n.task-activity {\n  margin-top: 1.25rem;\n}\n\n.task-activity h4,\n.task-dialog-main h4 {\n  margin: 0;\n}\n\n.task-activity-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.task-activity-head .btn-secondary {\n  width: auto;\n}\n\n.task-dropzone {\n  margin-bottom: 1.25rem;\n  padding: 0.65rem;\n  border: 1px dashed #cbd5e1;\n  border-radius: 0.6rem;\n  background: #f8fafc;\n}\n\n.task-dropzone.is-active {\n  border-color: #4f46e5;\n  background: #eef2ff;\n}\n\n.task-attachment-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.task-attachment {\n  width: 8.5rem;\n  margin: 0;\n}\n\n.task-attachment-preview,\n.task-attachment-file {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 6.5rem;\n  padding: 0;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.45rem;\n  background: #fff;\n  cursor: pointer;\n}\n\n.task-attachment-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.task-attachment-file {\n  padding: 0.5rem;\n  color: #1e293b;\n  font-size: 0.78rem;\n  text-align: center;\n}\n\n.task-attachment figcaption {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.35rem;\n  margin-top: 0.25rem;\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n.task-attachment figcaption span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.task-attachment figcaption button,\n.task-comment-meta button {\n  border: none;\n  background: none;\n  color: #64748b;\n  font: inherit;\n  cursor: pointer;\n}\n\n.task-comments {\n  list-style: none;\n  margin: 0.65rem 0 0.85rem;\n  padding: 0;\n}\n\n.task-comment {\n  display: grid;\n  grid-template-columns: 1.75rem minmax(0, 1fr);\n  column-gap: 0.65rem;\n  align-items: start;\n  margin-bottom: 0.9rem;\n}\n\n.task-comment .task-avatar {\n  width: 1.75rem;\n  height: 1.75rem;\n  margin-top: 0.1rem;\n}\n\n.task-comment-body {\n  min-width: 0;\n}\n\n.task-comments p {\n  margin: 0.15rem 0 0;\n  color: #1e293b;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.task-comment-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.35rem 0.5rem;\n}\n\n.task-comment-meta strong {\n  color: #172b4d;\n}\n\n.task-comment-meta .muted {\n  margin-right: auto;\n}\n\n.task-comment-form {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.45rem;\n}\n\n.task-comment-form textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.45rem;\n  font: inherit;\n  resize: vertical;\n}\n\n.mail-page-intro {\n  overflow-wrap: anywhere;\n}\n\n.mail-client {\n  display: grid;\n  grid-template-columns: minmax(16rem, 22rem) minmax(0, 1fr);\n  gap: 1rem;\n  align-items: start;\n}\n\n.mail-list,\n.mail-reader {\n  min-width: 0;\n}\n\n.mail-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin-bottom: 0.65rem;\n}\n\n.mail-toolbar-actions,\n.mail-folders {\n  display: grid;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.mail-toolbar-actions {\n  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);\n}\n\n.mail-folders {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.mail-toolbar-actions button,\n.mail-folders button {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding-left: 0.35rem;\n  padding-right: 0.35rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mail-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.mail-search {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  margin: 0 0 0.75rem;\n  min-width: 0;\n}\n\n.mail-search .form-control {\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n  box-shadow: none;\n}\n\n.mail-search .btn-secondary {\n  flex: 0 0 auto;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  white-space: nowrap;\n}\n\n.mail-search:focus-within .form-control {\n  border-right: 1px solid #0d6efd;\n  margin-right: -1px;\n  position: relative;\n  z-index: 1;\n}\n\n.mail-search:focus-within .btn-secondary {\n  border-color: #0d6efd;\n  position: relative;\n  z-index: 1;\n}\n\n.mail-compose input,\n.mail-compose textarea {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.mail-list-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.15rem;\n  width: 100%;\n  margin-bottom: 0.45rem;\n  padding: 0.7rem 0.8rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.55rem;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n}\n\n.mail-list-item.is-active {\n  border-color: #7c3aed;\n  background: #f5f3ff;\n}\n\n.mail-list-item .is-unread {\n  font-weight: 700;\n}\n\n.mail-preview {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.mail-subject {\n  margin: 0 0 0.35rem;\n}\n\n.mail-body {\n  margin: 0.75rem 0;\n  padding: 0.9rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.55rem;\n  background: #fff;\n  overflow: auto;\n  max-height: 32rem;\n  line-height: 1.45;\n}\n\n.mail-body img {\n  max-width: 100%;\n  height: auto;\n}\n\n.mail-file-list {\n  list-style: none;\n  margin: 0.35rem 0 0;\n  padding: 0;\n}\n\n.mail-file-list li,\n.mail-attachments li {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.mail-signature {\n  margin: 0.5rem 0 0.75rem;\n  padding: 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.55rem;\n  background: #fff;\n}\n\n.mail-attachments {\n  list-style: none;\n  margin: 0 0 0.75rem;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.mail-back {\n  display: none;\n  margin-bottom: 0.5rem;\n}\n\n.mail-toolbar .is-active {\n  border-color: #7c3aed;\n  color: #5b21b6;\n}\n\n@media (max-width: 800px) {\n  .mail-client {\n    grid-template-columns: 1fr;\n  }\n\n  .mail-client.has-selection .mail-list {\n    display: none;\n  }\n\n  .mail-client:not(.has-selection) .mail-reader {\n    display: none;\n  }\n\n  .mail-back {\n    display: inline-flex;\n  }\n}\n\n.searchable-select {\n  position: relative;\n  display: block;\n  width: 100%;\n  min-width: 0;\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  height: auto !important;\n  min-height: 0 !important;\n  appearance: none;\n}\n\n.searchable-select-trigger {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #0f172a;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 14px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.45rem;\n  padding: 0.55rem 2.25rem 0.55rem 0.85rem;\n  box-shadow: 0 1px 2px rgb(15 23 42 / 4%);\n}\n\n.searchable-select-value {\n  display: block;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.searchable-select-trigger:hover:not(:disabled) {\n  border-color: #94a3b8;\n}\n\n.searchable-select-trigger:focus,\n.searchable-select.is-open .searchable-select-trigger {\n  border-color: #0d6efd;\n  outline: 0;\n  box-shadow: 0 0 0 3px rgb(13 110 253 / 15%);\n}\n\n.searchable-select-trigger:disabled {\n  background-color: #f8fafc;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.searchable-select-trigger.form-select-sm {\n  padding: 0.25rem 1.8rem 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.375rem;\n}\n\n.searchable-select-native {\n  position: absolute;\n  inset: auto 0 0;\n  width: 100%;\n  height: 1px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.searchable-select-menu {\n  position: fixed;\n  z-index: 1400;\n  display: flex;\n  flex-direction: column;\n  max-height: min(20rem, calc(100vh - 16px));\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.5rem;\n  box-shadow: 0 12px 32px rgb(15 23 42 / 16%);\n  overflow: hidden;\n}\n\n.searchable-select-search {\n  margin: 0.4rem;\n  padding: 0.4rem 0.6rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.4rem;\n  font: inherit;\n  font-size: 0.9rem;\n  color: #0f172a;\n  background: #fff;\n}\n\n.searchable-select-search:focus {\n  border-color: #0d6efd;\n  outline: 0;\n  box-shadow: 0 0 0 3px rgb(13 110 253 / 15%);\n}\n\n.searchable-select-list {\n  overflow: auto;\n  padding: 0.15rem 0.15rem 0.35rem;\n}\n\n.searchable-select-option {\n  display: block;\n  width: 100%;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  padding: 0.4rem 0.55rem;\n  border-radius: 0.35rem;\n  font: inherit;\n  font-size: 0.9rem;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.searchable-select-option.is-active,\n.searchable-select-option:hover:not(:disabled) {\n  background: #eef2ff;\n}\n\n.searchable-select-option.is-selected {\n  font-weight: 600;\n}\n\n.searchable-select-option:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.searchable-select-empty {\n  margin: 0;\n  padding: 0.35rem 0.7rem 0.65rem;\n  color: #64748b;\n  font-size: 0.85rem;\n}\n\n.task-filter-selects .searchable-select,\n.row-actions > .searchable-select,\n.audit-filters .searchable-select,\n.pm2-logs-controls .searchable-select,\n.pdf-word-zoom .searchable-select {\n  width: auto;\n}\n\n.task-filter-selects .searchable-select-trigger {\n  width: auto;\n  min-width: 8.5rem;\n  padding: 0.28rem 1.7rem 0.28rem 0.45rem;\n  border-radius: 0.45rem;\n  font-size: 0.82rem;\n  box-shadow: none;\n}\n\n.row-actions > .searchable-select {\n  min-width: 14rem;\n}\n\n.audit-filters .searchable-select {\n  flex: 0 1 auto;\n  min-width: 9rem;\n  max-width: 16rem;\n}\n\n.pdf-word-zoom .searchable-select-trigger {\n  width: auto;\n  height: 26px;\n  padding: 0 1.5rem 0 6px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  box-shadow: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
